"use strict";
/*globals BaseAPI: false */

/**
 * C'est un plugin jQuery qui construira une grille interactive
 */
function Grid(target, options) {
	var self = this;

	// Injection des options par défaut
	options = $.extend({}, this.defaultOptions, options);

	// Construction du conteneur de la grille
	this.target = $(target).addClass('bbm-grid')
		.toggleClass('bbm-grid-without-pagination', options.pageSize === false)
		.toggleClass('bbm-grid-without-fixed-columns', !options.useFixedColumns)
		.toggleClass('bbm-grid-without-fixed-row-height', !options.useFixedRowHeight && !options.useFixedColumns && !options.scrollable)
		.toggleClass('bbm-grid-bordered', options.bordered)
		.toggleClass('bbm-grid-with-top-footers', options.footersOnTop)
		.html(''
		+ '<div class="bbm-grid-main">'
		+ '  <div class="bbm-grid-top">'
		+ '    <div class="bbm-grid-left"><table class="bbm-grid-table"><thead><tr class="bbm-grid-header-row" /><tr class="bbm-grid-filter-row" /></thead></table></div>'
		+ '    <div class="bbm-grid-center"><table class="bbm-grid-table"><thead><tr class="bbm-grid-header-row" /><tr class="bbm-grid-filter-row" /></thead></table></div>'
		+ '    <div class="bbm-grid-right"><table class="bbm-grid-table"><thead><tr class="bbm-grid-header-row" /><tr class="bbm-grid-filter-row" /></thead></table></div>'
		+ '  </div>'
		+ '  <div class="bbm-grid-group"></div>'
		+ '  <div class="bbm-grid-middle">'
		+ '    <div class="bbm-grid-left"><table class="bbm-grid-table"><tbody><tr class="bbm-grid-layout-row" /></tbody></table></div>'
		+ '    <div class="bbm-grid-center"><table class="bbm-grid-table"><tbody><tr class="bbm-grid-layout-row" /></tbody></table></div>'
		+ '    <div class="bbm-grid-right"><table class="bbm-grid-table"><tbody><tr class="bbm-grid-layout-row" /></tbody></table></div>'
		+ '  </div>'
		+ '  <div class="bbm-grid-bottom">'
		+ '    <div class="bbm-grid-left"><table class="bbm-grid-table"><tfoot><tr class="bbm-grid-layout-row" /><tr class="bbm-grid-footer-row" /></tfoot></table></div>'
		+ '    <div class="bbm-grid-center"><table class="bbm-grid-table"><tfoot><tr class="bbm-grid-layout-row" /><tr class="bbm-grid-footer-row" /></tfoot></table></div>'
		+ '    <div class="bbm-grid-right"><table class="bbm-grid-table"><tfoot><tr class="bbm-grid-layout-row" /><tr class="bbm-grid-footer-row" /></tfoot></table></div>'
		+ '  </div>'
		+ '</div>'
		+ '<div class="bbm-grid-scroll bbm-grid-scroll-v"><span class="bbm-grid-scroll-handle" /></div>'
		+ '<div class="bbm-grid-scroll bbm-grid-scroll-h"><span class="bbm-grid-scroll-handle" /></div>'
		+ '<div class="bbm-grid-pagination">'
		+ '  <div class="btn-group">'
		+ '    <button type="button" class="btn btn-link">' + this.defaultOptions.moveToFirstPageHTML + '</button>'
		+ '    <button type="button" class="btn btn-link">' + this.defaultOptions.moveToPreviousPageHTML + '</button>'
		+ '    <button type="button" class="btn btn-link">' + this.defaultOptions.moveToNextPageHTML + '</button>'
		+ '    <button type="button" class="btn btn-link">' + this.defaultOptions.moveToLastPageHTML + '</button>'
		+ '  </div>'
		+ '  <span>1-10 of 100</span>'
		+ '  <select><option>10</option><option selected>20</option><option>50</option><option>100</option><option>1000</option><option>10000</option></select>'
		+ '  <label>Rows per page</label>'
		+ '</div>');

	// Récupération de certaines parties une fois pour toute plutôt que de chercher à chaque fois dans un arbre DOM plus complexe
	this.components = {};
	this.components.top = this.target.find('>.bbm-grid-main>.bbm-grid-top');
	this.components.group = this.target.find('>.bbm-grid-main>.bbm-grid-group');
	this.components.middle = this.target.find('>.bbm-grid-main>.bbm-grid-middle');
	this.components.bottom = this.target.find('>.bbm-grid-main>.bbm-grid-bottom');
	this.components.left = this.target.find('>.bbm-grid-main>*>.bbm-grid-left');
	this.components.right = this.target.find('>.bbm-grid-main>*>.bbm-grid-right');
	this.components.center = this.target.find('>.bbm-grid-main>*>.bbm-grid-center');
	this.components.vscroll = this.target.find('>.bbm-grid-scroll-v');
	this.components.hscroll = this.target.find('>.bbm-grid-scroll-h');
	this.components.pagination = this.target.children('.bbm-grid-pagination');

	// Autres propriétés plus spécifiques à la grille elle-même
	this.lang = this.langs[options.lang];
	this.columns = options.columns;
	this.rows = options.rows;
	this.selectedRow = null;
	this.visibleRows = []; // cf updateFilters plus bas qui calculera les lignes visibles
	this.singleFilteredRows = []; // cf updateFilters plus bas qui calculera les lignes filtrées mais par une seule colonne
	this.pageIndex = 0;
	this.pageSize = options.pageSize === false ? 1e7 : options.pageSize;
	this.useFixedRowHeight = options.useFixedRowHeight;
	this.useFixedColumns = options.useFixedColumns;
	this.leftColumnCount = options.saveState ? (options.saveState.leftColumnCount || 0) : options.useFixedColumns ? (options.leftColumnCount || 0) : 0;
	this.rightColumnCount = options.saveState ? (options.saveState.rightColumnCount || 0) : options.useFixedColumns ? (options.rightColumnCount || 0) : 0;
	this.dropColumnWidth = options.dropColumnWidth;
	this.defaultColumnWidth = options.defaultColumnWidth;
	this.editable = options.editable;
	this.selectable = options.selectable;
	this.scrollable = options.scrollable;
	this.oneditrow = options.oneditrow;
	this.oneditcell = options.oneditcell;
	this.onchange = undefined; // pas une option mais une callback créée dans "internalConnectEvents" pour détecter les changements
	this.onvalidate = options.onvalidate;
	this.onerror = options.onerror;
	this.oncustomize = options.oncustomize;
	this.rowFilters = options.rowFilters || [];
	this.postFilters = options.postFilters;
	this.sortColumn = options.saveState ? this.findColumnByName(options.saveState.sortColumnName) : null;
	this.sortAscending = options.saveState ? !!options.saveState.sortAscending : false;
	this.groupColumn = options.saveState ? this.findColumnByName(options.saveState.groupColumnName) : null;
	this.groupAscending = options.saveState ? !!options.saveState.groupAscending  : false;
	this.groupRows = [];

	// On applique le saveState s'il est fournit
	if (options.saveState && options.saveState.columns) {
		var saveStateCols = options.saveState.columns;
		var orderedSizedColumns = [];

		// On récupère les colonnes de l'utilisateur
		saveStateCols.forEach(function(col) {
			var colFound = self.findColumnByName(col.name);
			if (colFound) {
				if (typeof col.size === 'string')
					col.size = parseInt(col.size);
				if (col.size)
					colFound.setWidth(col.size);
				orderedSizedColumns.push(colFound);
			}
		});

		this.columns = orderedSizedColumns;
	}

	// Ajustement du squelette de la grille en fonction des options données, notamment la langue et la visibilité
	this.components.top.find('.bbm-grid-filter-row').toggle((options.saveState && (typeof options.saveState.filters === 'boolean')) ? options.saveState.filters : options.filters);
	this.components.group.hide();
	this.components.bottom.toggle(options.footers && options.columns.some(function (column) { return !!column.footer; }));
	this.components.pagination.children('select').val(options.pageSize.toString());
	this.components.pagination.children('label').text(this.lang.paginationRowsPerPage);
	this.components.pagination.find('>.btn-group>:first-child').attr('title', this.lang.paginationFirstPage)
		.next().attr('title', this.lang.paginationPreviousPage)
		.next().attr('title', this.lang.paginationNextPage)
		.next().attr('title', this.lang.paginationLastPage);

	// C'est parti, on prépare l'affichage initial
	this.internalCreateColumns(options.saveState ? options.saveState.columns : null); // création des colonnes
	this.internalConnectEvents(options); // connexion des listeners et des plugins jQuery UI
	this.internalUpdateWidth(); // ajustement horizontal maintenant que les colonnes sont créées
	this.internalUpdateGridRows(); // ajout dans le tbody des lignes (vides si scrollable) de la page en cours
	this.internalUpdatePagination(); // ajustement de la pagination
	this.internalUpdateHeight(); // ajustement vertical maintenant que les lignes sont créées
	this.internalUpdateScrollableRows(true); // pour les grilles scrollable, afficher le contenu actuellement visible

	// Si le saveState comportait un tri ou un groupement on le(s) prend en compte
	if (this.sortColumn || this.groupColumn)
		this.updateSort();

	// Calcule visibleRows, met à jour les totaux, prévient les listeners et affiche la première page
	this.updateFilters();

	// Appliquer une largeur ajustée pour les colonnes dont un n'a pas précisée la largeur
	this.components.top.find('.ui-resizable-e').each(function(index, dom) {
		var self = $(dom);
		if (!self.closest('th').data('column').width)
			self.trigger('dblclick');
	});

	// Décaler le 'grid.pagechanged' pour être sûr que la grille soit accessible
	// aux listeners via ".grid()" une fois stockée dans ".data('grid')"
	setTimeout(function() {
		this.target.trigger('grid.pagechanged', [this.pageIndex, this.pageSize]);
	}.bind(this), 0);
}

Grid.prototype.destroy = function() {
	this.target.off('detectresize wheel');
	this.target.trigger('grid.rowcountchanged', null);
	this.target.removeClass('bbm-grid bbm-grid-bordered bbm-grid-without-vscroll bbm-grid-without-hscroll bbm-grid-without-pagination bbm-grid-without-fixed-columns bbm-grid-without-fixed-row-height bbm-grid-with-top-footers');
	this.target.empty();
};

Grid.prototype.internalConnectEvents = function(options) {
	// Ajuster l'affichage quand la taille change
	this.target.detectResize().on('detectresize', function() {
		this.internalUpdateWidth();
		this.internalUpdateHeight();
		this.internalUpdateScrollableRows(false);
	}.bind(this));

	// Scroll horizontal grâce au composant en bas
	var hscrollBar = this.components.hscroll;
	var hscrollCallback = function(event) {
		this.internalUpdateScrollLeft(event.clientX, null, null);
	}.bind(this);
	// Déplacement immédiat en cliquant dans la barre
	hscrollBar.on('click', hscrollCallback);
	// Déplacement à la souris en appuyant d'abord sur la barre
	hscrollBar.mouseDrag({ move: hscrollCallback });

	// Scroll vertical grâce au composant à droite
	var vscrollBar = this.components.vscroll;
	var vscrollCallback = function(event) {
		if (this.internalUpdateScrollTop(event.clientY, null, null)) {
			if (this.internalUpdateGroup(vscrollBar.data('currentScroll')))
				this.internalUpdateHeight();
			this.internalUpdateScrollableRows(false);
		}
	}.bind(this);
	// Déplacement immédiat en cliquant dans la barre
	vscrollBar.on('click', vscrollCallback);
	// Déplacement à la souris en appuyant d'abord sur la barre
	vscrollBar.mouseDrag({ move: vscrollCallback });

	// Ajuster le scroll vertical quand un des éléments "middle" bouge
	this.components.middle.children().on('scroll', function(event) {
		if (this.internalUpdateScrollTop(null, event.target.scrollTop, event.target)) {
			if (this.internalUpdateGroup(event.target.scrollTop))
				this.internalUpdateHeight();
			this.internalUpdateScrollableRows(false);
		}
	}.bind(this));

	// Ajuster le scroll horizontal quand un des éléments "center" bouge
	this.components.center.on('scroll', function(event) {
		this.internalUpdateScrollLeft(null, event.target.scrollLeft, event.target);
	}.bind(this));

	// Choix du nombre de ligne par page
	this.components.pagination.children('select').on('change', function(event) {
		this.pageSize = parseInt(event.target.value);
		this.pageIndex = 0;
		this.internalUpdateGridRows();
		this.internalUpdatePagination();
		this.internalUpdateGroup();
		this.internalUpdateHeight();
		this.internalUpdateScrollableRows(false);
		// On notifie le changement de page par un évènement
		this.target.trigger('grid.pagechanged', [this.pageIndex, this.pageSize]);
	}.bind(this));

	// Navigation dans les pages via 4 boutons (Première, précédente, suivante, dernière)
	this.components.pagination.find('>.btn-group>:first-child').on('click', this.moveToFirstPage.bind(this))
		.next().on('click', this.moveToPreviousPage.bind(this))
		.next().on('click', this.moveToNextPage.bind(this))
		.next().on('click', this.moveToLastPage.bind(this));

	// Filtre des lignes quand on change un filtre en en-tête de colonne
	this.components.top.find('tr.bbm-grid-filter-row').on('change', function() {
		this.updateFilters();
	}.bind(this));
	// Sous FF, Chrome et Edge, appuyer sur "Enter" lance un "onchange".
	// Sous IE11, que l'on identifie comme "Trident", ça n'est pas le cas alors on simule ce comportement
	if (navigator.userAgent.indexOf('Trident/') >= 0) {
		this.components.top.find('tr.bbm-grid-filter-row').on('keyup', function(event) {
			if (event.keyCode === 10 || event.keyCode === 13)
				$(event.target).change();
		});
	}

	// Redimensionnement des colonnes
	if (options.resizable) {
		// Utilisation du plugin jQuery UI "resizable"
		this.components.top.find('.resizable').resizable({
			// Les animations posent problème, notamment car "ui" n'est pas à jour dans le "stop"
			animate: false,
			helper: 'bbm-grid-resizer',
			handles: 'e',
			minWidth: this.defaultColumnWidth,
			stop: function(event, ui) {
				// La colonne redimensionnée
				var column = ui.element.data('column');
				// La nouvelle taille pour la colonne
				var newWidth = Math.floor(ui.element.outerWidth());
				// L'ancienne taille
				var oldWidth = column.width;
				// Mettre à jour l'IHM
				var cellIndex = ui.element.index();
				var position = ui.element.closest('table').parent()[0].className;
				var layoutCells = this.target.find('>.bbm-grid-main>*>.' + position + '>table>*>tr.bbm-grid-layout-row>th:nth-child(' + (cellIndex + 1) + ')');
				layoutCells.css('width', newWidth + 'px');
				// Mettre à jour la colonne
				column.setWidth(newWidth);
				// Prévenir les éventuels listeners
				this.target.trigger('grid.columnresized', [column, oldWidth, newWidth]);
				// Ajuster les ascenseurs
				this.internalUpdateWidth();
			}.bind(this)
		});

		// Mise en place de l'auto-dimensionnement des colonnes en double-cliquant sur la droite de la colonne
		this.components.top.on('dblclick', '.ui-resizable-e', function(event) {
			// l'en-tête de la colonne à ajuster
			var th = $(event.target.parentNode);
			// la colonne en question
			var column = th.data('column');
			// la section bbm-grid-left/center/right où se trouve la colonne
			var className = th.closest('div')[0].className;
			// les 3 tables top/middle/bottom de cette section
			var tables = this.target.find('>.bbm-grid-main>*>.' + className + '>table');
			// les 3 cellules top/middle/bottom controllant la largeur
			var layoutCells = tables.find('>*>:first-child>:nth-child(' + (th.index()+1) + ')');
			// les cellules de la colonne contenant des données prises en compte dans l'ajustement (header, footer, détails)
			var dataCells = tables.find('>*>:not(.bbm-grid-layout-row)>:nth-child(' + (th.index()+1) + ')');
			// la ligne de filtre, qu'on va cacher pour ne pas la prendre en compte dans l'ajustement
			var filters = tables.find('>thead>tr.bbm-grid-filter-row:visible');
			// l'ancienne largeur
			var oldWidth = column.width;
			// la largeur ajustée
			var newWidth = null;
			filters.hide(); // on cache les filtres
			tables.css('width', 'auto'); // on laisse la table grandir
			layoutCells.css('width', 'auto'); // on laisse les cellules grandir
			dataCells.css('overflow', 'visible'); // on ne tronque plus le contenu
			dataCells.each(function(index, cell) { // on calcule la largeur max
				if (newWidth == null || cell.scrollWidth > newWidth)
					newWidth = Math.floor(cell.scrollWidth);
			});
			// Bizarrement, la ligne ayant le plus long texte a 1 ou 2 caractères remplacés par "..."
			// Du coup, on ajoute 10 pixels pour être sûr que "..." ne soit plus nécessaire
			newWidth += 10;
			// OK, on a notre nouvelle taille
			dataCells.css('overflow', '');
			layoutCells.css('width', newWidth + 'px');
			tables.css('width', '');
			filters.show();
			// Mettre à jour la colonne
			column.setWidth(newWidth);
			// Prévenir les éventuels listeners
			this.target.trigger('grid.columnresized', [column, oldWidth, newWidth]);
			// Ajuster les ascenseurs
			this.internalUpdateWidth();

			// Bloquer les autres dblclk
			event.preventDefault();
			event.stopPropagation();
		}.bind(this)).on('click', '.ui-resizable-e', function(event) {
			// Bloquer le clic pour ne pas lancer le tri
			event.preventDefault();
			event.stopPropagation();
		});
	}

	// Déplacement des colonnes
	if (options.moveable) {
		/*
		 * Si on déplace une colonne dans les parties fixes (gauche ou droite), le plugin "droppable" envoie 2 "drop" :
		 * - un "drop" sur la colonne fixe (OK)
		 * - un "drop" sur la colonne de la partie centrale qui se trouve derrière la colonne fixe (Argh !)
		 * C'est pourquoi on conservera le meilleur "drop" et on attendra le "drag stop" pour faire le déplacement.
		 */
		var bestDroppable = null;
		this.components.top.find('.moveable').draggable({
			appendTo: 'body',
			helper: 'clone',
			stop: function(event, ui) {
				if (bestDroppable !== null) {
					var srcHeader = $(event.target).closest('th');
					var dstHeader = $(bestDroppable);
					// Déplacement de la colonne
					this.internalMoveColumn(srcHeader, dstHeader);
					// Mise à jour des ascenseurs (quand ça change de zone gauche/centre/droit)
					this.internalUpdateWidth();
					bestDroppable = null;
				}
			}.bind(this)
		});
		this.components.top.find('tr.bbm-grid-header-row>*').droppable({
			activeClass: 'droppable',
			hoverClass: 'bg-success',
			accept: '#' + this.target.attr('id') + ' .moveable',
			drop: function(event, ui) {
				if (bestDroppable === null // premier drop
					|| $(event.target).closest('table').parent().is(':not(.bbm-grid-center)')) // drop sur une colonne fixe
					bestDroppable = event.target;
			}
		});
	}

	// Tri des colonnes
	if (options.sortable) {
		this.components.top.on('click', '.sortable', function(event) {
			// On s'assure que ça n'est pas un redimensionnement
			if ($(event.target).hasClass('ui-resizable-resizing') || $(event.target).hasClass('ui-resizable-handle'))
				return;
			// On s'assure que c'est bien un clic gauche
			if (event.originalEvent.button !== 0)
				return;
			// OK, on ajuste le tri
			var column = $(event.target).closest('th').data('column');
			this.sortCol(column, this.sortColumn === column ? !this.sortAscending : true);
		}.bind(this));
	}

	// Regroupement des colonnes
	if (options.groupable) {
		// Le regroupement se fait en appuyant sur une en-tête. Un popover est créé et apparait en décalé. ce popover permet de choisir une actions
		this.components.top.on('contextmenu', '.groupable', function(event) {
			// Le .groupable ayant fait apparaitre les actions
			var columnActionsPopoverSource = $(event.target);

			// S'assurer d'attraper les "mouseup" en écoutant sur le "body" pour détruire les popovers
			$(document.body).one('mouseup', function() {
				columnActionsPopoverSource.popover('destroy');
			});

			// on crée le contenu du "popover", qui n'est qu'un texte HTML statique
			var popoverContent = $(''
				+ '<div class="grid-column-actions">'
				+ '  <ul class="list-group" style="cursor: pointer; ">'
				+ '    <li class="list-group-item" data-sort="true" data-ascending="true">' + this.lang.columnSortAscending + '</li>'
				+ '    <li class="list-group-item" data-sort="true" data-ascending="false">' + this.lang.columnSortDescending + '</li>'
				+ '    <li class="list-group-item" data-sort="false" data-ascending="true">' + this.lang.columnGroupAscending + '</li>'
				+ '    <li class="list-group-item" data-sort="false" data-ascending="false">' + this.lang.columnGroupDescending + '</li>'
				+ '  </ul>'
				+ '</div>')[0];

			// on crée le "popover"
			columnActionsPopoverSource.popover({
				trigger: 'manual',
				placement: 'bottom', // en dessous de l'en-tête pressée
				container: '#' + this.target.attr('id'), // à l'intérieur de la grille pour éviter les problème de "z-index"
				title: this.lang.columnPopoverTitle, // titre par défaut du popover
				html: true, // le contenu retourné dans "content" sera de l'HTML
				content: popoverContent
			}).on('hidden.bs.popover', function () {
				// Le popover déplacer "title" dans "data-original-title" et vide "title" mais ne le restaure pas à la fin.
				// Du coup, pour conserver le "title" des colonnes, on doit corriger nous-mêmes.
				columnActionsPopoverSource.attr('title', columnActionsPopoverSource.attr('data-original-title') || '');
			}).on('inserted.bs.popover', function() {
				// Quand le "popover" est ajouté à l'arbre DOM, on le cache jusqu'au "timeout" et on active le plugin droppable
				this.target.children('.popover').on('click', '.list-group-item', function(event) {
					var droppable = $(event.target),
						column = columnActionsPopoverSource.closest('th').data('column'),
						sort = 'true' === droppable.attr('data-sort'),
						ascending = 'true' === droppable.attr('data-ascending');
					if (sort) {
						this.sortCol(column, ascending);
					} else {
						this.groupCol(column, ascending);
					}
				}.bind(this));
			}.bind(this)).popover('show');

			// Renvoyer "false" dans "contextmenu" évite le menu par défaut du clic droit
			return false;
		}.bind(this));

		// Ensuite, enregistrer sur la grille un écouteur pour capter les clics sur les boutons de suppression du regroupement
		this.target.children('.bbm-grid-main').on('click', 'a.bbm-grid-remove-group', function(event) {
			// '#' dans l'URL
			event.preventDefault();
			// Si pas de tri, on utiliser la colonne du regroupement comme tri pour avoir un ordre compréhensible
			if (!this.sortColumn) {
				// Le fait de faire un sortCol sur la colonne
				// de groupement, cela annuler implicitement le regroupement.
				this.sortCol(this.groupColumn, this.groupAscending);
			} else {
				this.groupCol(null, null);
			}
		}.bind(this));
	}

	// Sélection dans la grille
	if (options.selectable) {
		// Rendre éditable la ligne cliquée par l'utilisateur
		this.components.middle.on('click', 'tr.bbm-grid-row:not(.bbm-grid-selected)', function(event) {
			// Ne pas changer de ligne si on clique sur un "bouton"
			var target = $(event.target).closest('a, button');
			if (target.is('a,button'))
				return;
			// Conserver les infos sur la cellule cliquée
			var td = $(event.target).closest('td');
			var tr = td.parent();
			var index = td.index();
			// Sélectionner la ligne
			this.internalSelectRow(tr).then(function() {
				// Récupérer la cellule qui remplace la cellule cliquée
				td = $(tr.children()[index]);
				// Donner automatiquement le focus à la zone de saisie qu'elle contient
				td.find('.bbm-grid-nav-focusable').focus();
				// Simuler le clic dans la zone de saisie si demandé
				setTimeout(function() {
					td.find('.bbm-grid-nav-clickable').click();
				}, 100);
			});
		}.bind(this));

		// Sélectionner la valeur de l'input quand celle-ci prend le focus pour faciliter la saisie
		// L'avantage de le faire ici est que ça marche :
		// - pour le ".focus()" fait juste au dessus en sélectionant la ligne
		// - pour le ".focus()" fait lors de la navigation au clavier
		// - pour le cas où l'utilisateur donne le focus lui-même à la zone
		this.components.middle.on('focus', '.bbm-grid-nav-selectable', function(event) {
			setTimeout(function() {
				$(event.target).select();
			}, 100);
		});
	}

	// Détection des modifications dans la grille sans avoir besoin de changer de ligne
	if (options.editable) {
		// Stocke s'il y a des modifications en cours dans la grille pour lesquelles on n'a pas encore envoyé d'évènement
		var modified = false;
		// A chaque modification, marquer la grille comme modifée
		this.onchange = (function(event) {
			modified = true;
		}).bind(this);
		// Quand le focus sort de la partie centrale de la grille, on applique les éventuelles modifications.
		// Comme "blur" ne bubble pas, on utilise "focusout", supporté par IE, Edge, Chrome et Firefox (>= 52)
		// - https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event
		// - https://developer.mozilla.org/en-US/docs/Web/API/Element/focusout_event
		// - https://caniuse.com/#search=focusout
		// Pendant un temps, on s'est basé sur l'analyse de event.relatedTarget pour savoir si on sort de la grille.
		// - https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/relatedTarget
		// Malheureusement, cette propriété n'est pas toujours définie, par exemple sur le "focusout" d'un select sous Chrome.
		// - https://support.solvnet.fr:9998/devels/edit/3388
		// Du coup, on lance un timer dans focusout :
		// - soit le focus reste dans la même grille : on a alors un focusin qui annule le timeout
		// - soit le focus sort de la grille : le timeout arrive et appelle saveEditing
		var focusoutTimeout = null;
		var clearFocusoutTimeout = function() {
			if (focusoutTimeout) {
				clearTimeout(focusoutTimeout);
				focusoutTimeout = null;
			}
		};
		this.components.middle.on('focusin', clearFocusoutTimeout);
		this.components.middle.on('focusout', function(event) {
			// S'il n'y a pas eu de modification, rien à faire
			if (!modified)
				return;
			// Si on quitte une ligne même pas chargée, il n'y a encore rien à sauvegarder
			if ($(event.target).closest('tr').is('.bbm-grid-loadable'))
				return;
			// On attend de quitter la partie centrale de la grille pour sauvegarder, c'est à dire si le focus part
			clearFocusoutTimeout();
			focusoutTimeout = setTimeout(function() {
				this.saveEditing().then(function() {
					// Repasser modified à false uniquement en cas de succès
					modified = false;
				});
			}.bind(this), 200);
		}.bind(this));
	}

	// Navigation au clavier
	if (options.editable && options.keyboard) {
		/*
		 * Jusqu'au 03/08/2017, on utilisait le sélecteur non standard ":input:visible" de jQuery qui renvoie les composants visibles pouvant prendre le focus
		 * - http://api.jquery.com/input-selector/
		 * - http://api.jquery.com/visible-selector/
		 * Le 03/08/2017, la classe "bbm-grid-nav-focusable" et d'autres ont été créées pour gérer le focus à la sélection d'une ligne.
		 * Dorénavant, le sélecteur ".bbm-grid-nav-focusable" est donc utilisé car il permet aux colonnes de contrôles qui prend le focus.
		 */
		var keyboardNavigationSelector = '.bbm-grid-nav-focusable';
		this.components.middle.on('keydown', 'tr.bbm-grid-editing ' + keyboardNavigationSelector, function(event) {
			if (!event.ctrlKey) {
				var keyCode = event.which || event.keyCode;
				var controlPromise;
				switch (keyCode) {
				case 37:
					// Flêche gauche : on donne le focus à un composant à gauche sur la même ligne
					controlPromise = this.internalFindControlToFocus(event, keyboardNavigationSelector, false);
					break;
				case 39:
					// Flêche droite : on donne le focus à un composant à droite sur la même ligne
					controlPromise = this.internalFindControlToFocus(event, keyboardNavigationSelector, true);
					break;
				case 38:
					// Flêche haute : on donne le focus à un composant de la même colonne sur la ligne précédente
					controlPromise = this.internalFindRowToFocus(event, keyboardNavigationSelector, false, true);
					break;
				case 40:
					// Flêche basse : on donne le focus à un composant de la même colonne sur la ligne suivante
					controlPromise = this.internalFindRowToFocus(event, keyboardNavigationSelector, true, true);
					break;
				case 9:
					// Tab : on donne le focus à un composant avant/après, en changeant si besoin de ligne
					// Tab = on avance, Shift+Tab = on recule
					var forward = !event.shiftKey;
					// Recherche d'un champ sur la ligne
					controlPromise = this.internalFindControlToFocus(event, keyboardNavigationSelector, forward);
					// Si aucun champ trouvé après/avant sur la ligne, passer à la ligne suivante/précédente.
					// NB: ".fail" ne fonctionnait pas. Voir le bug signalé pour les explications
					// https://support.solvnet.fr:9998/devels/edit/2700
					controlPromise = controlPromise.then(undefined, function() {
						return this.internalFindRowToFocus(event, keyboardNavigationSelector, forward, false);
					}.bind(this));
					break;
				}
				if (controlPromise) {
					// preventDefault si on gère nous-même l'évènement
					event.preventDefault();

					// Sous Firefox, cela ne suffit malheureusement pas :
					// https://stackoverflow.com/a/25187237
					// https://support.solvnet.fr:9998/devels/edit/3190
					// https://support.solvnet.fr:9998/devels/edit/3249
					if (event.target.tagName === 'SELECT' && !event.target.disabled) {
						event.target.disabled = true;
						setTimeout(function() {
							event.target.disabled = false;
						}, 0);
					}

					// Enfin, donner le focus au contrôle trouvé
					controlPromise.then(function(control) {
						control.focus(); // inutile de faire le .select() car la grille le fera automatiquement sur "on('focus', ...)"
					});
				}
			}
		}.bind(this));
	}

	// Ajuster la position des dropdowns (down ou up ?)
	this.components.middle.on('show.bs.dropdown', function(event) {
		var dropdown = $(event.target);
		var offset = dropdown.closest('tr').offset().top - this.components.middle.offset().top;
		var maxHeight = this.components.middle.innerHeight();
		if (offset > maxHeight - offset - 30) {
			// Plus de place en haut que en bas => on l'affiche vers le haut
			dropdown.addClass('dropup');
			dropdown.find('.dropdown-menu').css({ 'max-height': (offset - 20) + 'px', 'overflow': 'auto' });
		} else {
			// Plus de place en bas que en haut => on l'affiche vers le bas
			dropdown.removeClass('dropup');
			dropdown.find('.dropdown-menu').css({ 'max-height': (maxHeight - offset - 50) + 'px', 'overflow': 'auto' });
		}
	}.bind(this));
};

/**
 * Cette méthode n'est appelée qu'une fois dans le constructeur de la grille pour créer les colonnes, c'est à dire :
 * - dans le thead>tr.bbm-grid-header-row, une cellule pour le titre (sert aussi à respecter la largeur)
 * - dans le thead>tr.bbm-grid-filter-row, une cellule pour le composant de filtre (facultatif)
 * - dans le tbody>tr.bbm-grid-layout-row, une cellule de 0px de haut pour respecter la largeur
 * - dans le tfoot>tr.bbm-grid-layout-row, une cellule de 0px de haut pour respecter la largeur
 * - dans le tfoot>tr.bbm-grid-footer-row, une cellule pour le composant de filtre (facultatif)
 */
Grid.prototype.internalCreateColumns = function(saveStateColumns) {
	var self = this;
	var filtersMap = {};
	if (saveStateColumns)
		saveStateColumns.forEach(function(c){
			filtersMap[c.name] = c.filter;
		});

	function build(columns, selector, fitWidth) {
		var layout = selector.find('>table>*>tr.bbm-grid-layout-row'); // 2 lignes cachées pour dimensionner correctement dans "tbody" et "tfoot"
		var header = selector.find('>table>*>tr.bbm-grid-header-row');
		var filter = selector.find('>table>*>tr.bbm-grid-filter-row');
		var footer = selector.find('>table>*>tr.bbm-grid-footer-row');
		columns.forEach(function(column) {
			// Récupérer le titre
			var title = typeof column.title === 'function' ? column.title() : column.title;
			// Header cell
			var headerCell = $('<th />')
				.data('column', column)
				.css('text-align', column.align)
				.css('width', (column.width || self.defaultColumnWidth) + 'px')
				.toggleClass('bbm-grid-hidden', !!column.hidden)
				.toggleClass('sortable', column.sortable)
				.toggleClass('resizable', column.resizable);

			// Column title
			$('<span />')
				.append(title)
				.attr('title', typeof title === 'string' ? column.title : '')
				.addClass('moveable')
				.toggleClass('groupable', column.groupable)
				.appendTo(headerCell);

			// Filter
			var filterCell = $('<th />')
				.data('column', column)
				.toggleClass('bbm-grid-hidden', !!column.hidden);
			if (column.createFilter) {
				var domFilter = column.createFilter(filterCell, self.lang);
				if (saveStateColumns && filtersMap[column.name])
					column.loadFilter(domFilter, filtersMap[column.name]);
			}

			// Footer
			var footerCell = $('<th />').toggleClass('bbm-grid-hidden', !!column.hidden);
			if (column.footer)
				footerCell.css('text-align', column.align); // pas besoin de préciser s'il n'y a pas de footer
			if (typeof column.footer === 'string')
				footerCell.append(column.footer);
			else if (typeof column.footer === 'function')
				column.footer(column, footerCell, self.visibleRows);
			//else
			//	Object { initialize, add, finalize } traité dans Grid.prototype.internalUpdateFooters

			layout.append($('<th />').css('width', (column.width || self.defaultColumnWidth) + 'px').toggleClass('bbm-grid-hidden', !!column.hidden));
			header.append(headerCell);
			filter.append(filterCell);
			footer.append(footerCell);
		});
		// On ajoute ensuite une colonne supplémentaire (de "td" plutôt que "th" afin de les différencier) :
		// - à gauche et à droite, de largeur fixe, pour pouvoir ajouter dans colonnes fixes, si l'option est activée
		// - au centre pour occuper la largeur restante (grâce au 100%), et éventuellement pour permettre le drop de colonnes
		if (self.useFixedColumns || fitWidth) {
			layout.append($('<td class="bbm-grid-drop-cell" />').css('width', fitWidth ? "100%" : (self.dropColumnWidth + 'px')));
			header.append($('<td class="bbm-grid-drop-cell" />').css('width', fitWidth ? "100%" : (self.dropColumnWidth + 'px')));
			filter.append('<td class="bbm-grid-drop-cell" />');
			footer.append('<td class="bbm-grid-drop-cell" />');
		}
	}

	var leftColumns = this.columns.slice(0, this.leftColumnCount);
	var rightColumns = this.columns.slice(this.columns.length - this.rightColumnCount, this.columns.length);
	var centerColumns = this.columns.slice(this.leftColumnCount, this.columns.length - this.rightColumnCount);
	build(leftColumns, this.components.left, false);
	build(rightColumns, this.components.right, false);
	build(centerColumns, this.components.center, true);
};

/*
 * Cette méthode génère les lignes correspondant à la page en cours dans "tbody" avec les regroupements éventuels.
 * En sortie, this.groupRows aura en plus été rempli avec les lignes de regroupement afin d'optimiser la recherche pendant le scroll.
 */
Grid.prototype.internalUpdateGridRows = function() {
	var self = this;
	var offset = this.pageIndex * this.pageSize;
	var pageRows = this.visibleRows.slice(offset, offset + this.pageSize);

	function build(selector, startIndex, endIndex, fitWidth) {
		var columns, tbody;
		if (startIndex < endIndex || self.useFixedColumns) {
			columns = self.columns.slice(startIndex, endIndex);
			tbody = selector.find('>table>tbody');
			tbody.children(':not(:first-child)').remove();
			var trArray = [];
			var currentGroupContent = null;
			var groupButton = '<a href="#" class="bbm-grid-remove-group" title="' + self.lang.columnRemoveGrouping + '">' + self.defaultOptions.removeGroupHTML + '</a>';
			var groupColumnTitle = self.groupColumn ? (typeof self.groupColumn.title === 'function' ? self.groupColumn.title() : self.groupColumn.title) : '';
			pageRows.forEach(function(row, rowIndex) {
				// En cas de regroupement
				if (self.groupColumn) {
					// On calcule le contenu du regroupement
					var groupContent = self.groupColumn.ready ? self.groupColumn.groupContent(row) : '...';
					// En cas de changement de groupe, on ajoute une ligne entre-deux en "colspan" avec le contenu donné
					if (rowIndex === 0 || groupContent !== currentGroupContent) {
						var groupRow = $('<tr class="bbm-grid-group-row" />').data('row', row).get(0);
						var groupCell = $('<td />').attr('colspan', endIndex - startIndex + 1/*drop column*/).appendTo(groupRow);
						if (startIndex === 0) {
							groupCell.text(groupColumnTitle + ' : ' + groupContent);
							if (rowIndex === 0)
								groupCell.append(groupButton);
							self.groupRows.push(groupRow);
						}
						trArray.push(groupRow);
						currentGroupContent = groupContent;
					}
				}

				// La ligne de donnée
				var tr = $('<tr class="bbm-grid-row" />').data('row', row);
				if (self.scrollable) {
					// Si les lignes ne sont chargées qu'au moment où elles deviennent visibles, on crée une seule cellule pour occuper la place
					if (columns.length > 0)
						$('<td />').attr('colspan', columns.length).appendTo(tr);
					tr.addClass('bbm-grid-loadable');
				} else {
					// Sinon, pour les grilles pas trop grosses, on charge toutes les lignes
					columns.forEach(function(col) {
						var content = col.ready ? col.content(row) : self.defaultOptions.notReadyHTML;
						var td = $('<td />').appendTo(tr).append(content).css('text-align', col.align).toggleClass('bbm-grid-hidden', !!col.hidden);
						if (self.oncustomize)
							self.oncustomize(td, col, row, false);
					});
				}
				if (self.useFixedColumns || fitWidth)
					tr.append('<td class="bbm-grid-drop-cell">&nbsp;</td>');
				trArray.push(tr[0]);
			});
			tbody.append(trArray);
		}
	}

	this.groupRows.length = 0;
	this.selectedRow = null;

	build(this.components.middle.children('.bbm-grid-left'), 0, this.leftColumnCount, false);
	build(this.components.middle.children('.bbm-grid-right'), this.columns.length - this.rightColumnCount, this.columns.length, false);
	build(this.components.middle.children('.bbm-grid-center'), this.leftColumnCount, this.columns.length - this.rightColumnCount, true);

	// mettre à jour la table du centre en fonction de la position du currentScroll (left) sauvegardé
	// https://support.solvnet.fr:9998/devels/edit/3111
	this.components.middle.children('.bbm-grid-center').scrollLeft(this.components.hscroll.data('currentScroll'));
};

/**
 * Cette fonction recherche la première ligne visible (même partiellement) et charge son contenu et
 * celui des lignes suivantes jusqu'en bas de la partie visible de la grille.
 *
 * Pour ne pas surcharger quand un scroll envoie plein d'évènements, on attend de voir si un autre
 * évènement arrive juste après. Seul le dernier évènement de la série va ainsi charger réellement
 * les lignes. Le paramètre "now" permet de forcer l'affichage immédiat, comme au chargement initial
 *
 * @param {boolean} now - permet de forcer le rafraichissement immédiat. Dans le cas d'un scroll, on attend un peu avant de charger
 */
Grid.prototype.internalUpdateScrollableRows = function(now) {
	var self = this;
	if (!this.scrollable)
		return;

	function updateScrollable() {
		var div = self.components.middle.children('.bbm-grid-center');
		var minOffset = div[0].scrollTop;
		var maxOffset = minOffset + div.innerHeight();
		var visibleRowIndex = 0;
		var visibleRowOffset = 0;
		var visibleRows = div.find('>table>tbody>.bbm-grid-row').get();
		BaseAPI.arrayDichotomique(visibleRows, function(row, index) {
			var offset = row.offsetTop;

			// Si la ligne commence strictement après le début de la grille, c'est trop bas.
			if (offset > minOffset)
				// On cherche avant, dans la moitié gauche (retourne -1)
				return -1;

			// Si la ligne se termine strictement avant le début de la grille, c'est trop haut.
			if (offset + row.offsetHeight < minOffset)
				// On cherche après, dans la moitié droite (retourne 1)
				return 1;

			// Sinon, la ligne est la première visible
			visibleRowIndex = index;
			visibleRowOffset = offset;
			// On arrête la recherche (retourne 0)
			return 0;
		});
		// Pour chaque ligne visibles en partant du haut jusqu'en bas, on affiche le contenu
		while (visibleRowIndex < visibleRows.length && visibleRowOffset < maxOffset) {
			self.updateRow(visibleRows[visibleRowIndex]);
			visibleRowOffset += visibleRows[visibleRowIndex].offsetHeight;
			visibleRowIndex++;
		}
	}

	// Si précisé explicitement, on prépare immédiatement les lignes visibles en fonction du scroll
	if (!!now) {
		updateScrollable();
		return;
	}
	// Sinon, si on reçoit un évènement "scroll" avant que le précédent ait été traité, on annule le timeout précédent
	if (this.scrollTimeout)
		clearTimeout(this.scrollTimeout);
	// Enfin, on démarre un timeout pour attendre de voir si un autre évènement "scroll" arrive juste après pour ne pas travailler pour rien
	this.scrollTimeout = setTimeout(function() {
		this.scrollTimeout = undefined;
		updateScrollable();
	}.bind(this), 200);
};

/**
 * Cette méthode modifie le contenu des 3 lignes left/center/right de "tableRows" en fonction de "modelRow".
 * Pour chaque cellule générée, on affichera au choix :
 * - un curseur d'attente si la colonne est encore en train de chargée (cf GridColumn.loading)
 * - l'HTML renvoyé par GridColumn.content si la cellule n'est pas modifiable (cf Grid.internelIsCellEditable)
 * - le contenu généré par GridColumn.createEditor si la cellule est modifiable
 *
 * @param {Object} tableRows - l'objet jQuery contenant les 3 lignes left/center/right dans lesquelles afficher le contenu
 * @param {Object} modelRow - la ligne, parmi this.rows à afficher
 * @param {boolean} selected - indique si la ligne est sélectionnée (true) ou non (false)
 * @param {boolean} editing - indique si la ligne éditable (true) ou non (false)
 */
Grid.prototype.internalUpdateRow = function(tableRows, modelRow, selected, editing) {
	var self = this;
	// On récupère la dernière cellule (celle servant au drop si colonnes fixe ou la colonne en colspan si une seule bande)
	var existingCells = tableRows.children(':last-child');
	// Cette fonction ajoutera les cellules des colonnes avant chaque cellule de drop de chaque table (left/center/right)
	function append(tableIndex, lang, columns, startIndex, endIndex) {
		var cell = $(existingCells[tableIndex]);
		cell.siblings().remove();
		cell.parent().prepend(columns.slice(startIndex, endIndex).map(function(column) {
			var td = $('<td />').attr('align', column.align).toggleClass('bbm-grid-hidden', !!column.hidden);
			var access = self.internalGetCellAccess(column, modelRow, editing);
			td.addClass(self.defaultOptions.cellClasses[access]);
			if (access === 'notready')
				td.append(self.defaultOptions.notReadyHTML);
			else if (access === 'readonly')
				td.append(column.content(modelRow));
			else
				column.createEditor(modelRow, td, lang, access === 'required', self.onchange);
			if (self.oncustomize)
				self.oncustomize(td, column, modelRow, selected);
			return td[0];
		}));
	}
	// On ajoute dans chaque table (left/center/right) les cellules associées
	if (this.useFixedColumns) {
		append(0, this.lang, this.columns, 0, this.leftColumnCount);
		append(1, this.lang, this.columns, this.leftColumnCount, this.columns.length - this.rightColumnCount);
		append(2, this.lang, this.columns, this.columns.length - this.rightColumnCount, this.columns.length);
	} else {
		append(0, this.lang, this.columns, 0, this.columns.length);
		existingCells.remove();
	}
	// Une fois prête, on marque la ligne comme chargée et éventuellement en édition et sélectionnée
	tableRows.removeClass('bbm-grid-loadable').toggleClass('bbm-grid-editing', editing).toggleClass('bbm-grid-selected', selected);
	// Conserver la référence sur la ligne sélectionnée
	if(selected) {
		this.selectedRow = modelRow;
	}
};

/**
 * Cette méthode indique le mode d'accès à la cellule à l'intersection de la colonne "column" et de la ligne "modelRow" éventuellement éditable.
 * Le résultat peut être :
 * <ul>
 * <li>'notready' : quand la colonne n'est pas encore prête
 * <li>'readonly' : si la ligne ou la colonne n'est pas éditable
 * <li>'editable' : si la cellule est éditable, sans être obligatoire
 * <li>'required' : si la cellule est éditable et obligatoire
 * </ul>
 *
 * @param column - la colonne, dont les champs "editable" et "required" serviront de droit par défaut
 * @param modelRow - l'objet métier dont on veut savoir si le champ est éditable
 * @param editing - indique si "modelRow" est actuellement sélectionnée, et donc en cours d'édition
 * @return le droit d'accès sous la forme d'un des textes suivants : 'notready', 'readonly', 'editable' ou 'required'
 */
Grid.prototype.internalGetCellAccess = function(column, modelRow, editing) {
	if (!column.ready)
		return 'notready';
	if (!editing || !column.createEditor)
		return 'readonly';
	var access = (this.oneditcell ? this.oneditcell(column, modelRow) : null) || column;
	if (! access.editable)
		return 'readonly';
	if (! access.required)
		return 'editable';
	return 'required';
};

/**
 * Cette méthode sélectionne SI POSSIBLE la ligne "tr" donnée et, le cas échéant, active le mode de modification.
 * Toutefois, elle sauvegarde d'abord la ligne en cours de modification et ne passe à la nouvelle ligne que si aucune erreur n'est levée.
 *
 * @param {Object} tr - l'objet jQuery représentant une ligne parmi les 3 left/center/right (les 2 autres sont recherchées automatiquement)
 * @return une promise résolue si le changement de ligne est possible, rejetée sinon (par exemple en cas d'erreur de saisie)
 */
Grid.prototype.internalSelectRow = function(tr) {
	// Récupérer les lignes sélectionnées
	var selectedTableRows = this.components.middle.find('>*>table>tbody>tr.bbm-grid-selected');
	// Récupérer les lignes en cours de modification
	var editingTableRows = selectedTableRows.filter('.bbm-grid-editing');
	// Le deferred retourné
	var defer;
	if (editingTableRows.length > 0) {
		// Demander d'appliquer les modifications
		defer = this.internalSaveRows(editingTableRows);
	} else {
		// Rien à appliquer donc tout va bien pour le moment
		defer = $.Deferred().resolve();
	}

	return defer.then(function() {
		// Sortir la ligne du mode "sélection" (et implicitement du mode "édition")
		if (selectedTableRows.length > 0) {
			// Chrome lance un "blur" lorsque l'on va retirer la cellule ayant le focus
			// Pour ne pas déclencher une deuxième sauvegarde, on marque la ligne comme "loadable"
			selectedTableRows.addClass('bbm-grid-loadable');
			// Ensuite, on peut la redessiner (la classe "loadable" sera retirer dans la méthode "internalUpdateRow"
			this.internalUpdateRow(selectedTableRows, selectedTableRows.data('row'), false, false);
		}
		// Récupérer l'objet associé à la ligne
		var modelRow = tr.data('row');
		// Vérifier si la ligne est éditable
		var editable = this.editable && ((typeof this.oneditrow === 'undefined') || this.oneditrow(modelRow));
		// Récupérer les 3 lignes (left/center/right) correspondant à la ligne demandée
		var tableRows = this.components.middle.find('>*>table>tbody>tr:nth-child(' + (tr.index() + 1) + ')');
		// Commencer la modification de la ligne demandée
		this.internalUpdateRow(tableRows, modelRow, true, editable);
		// On notifie la selection de la ligne une fois que la ligne est prête
		this.target.trigger('grid.rowselected', [modelRow]);
	}.bind(this));
};

/**
 * Cette fonction sauvegarde la ligne en cours de modification. Pour cela :
 * - elle clone la ligne
 * - ensuite, elle appelle "validateAndApplyEditor" pour chaque colonne afin de vérifier la saisie et d'appliquer les modifications sur la ligne clonée
 * - ensuite, elle appelle l'éventuel "onvalidate" pour vérifier la cohérence de la ligne clonée dans son ensemble
 * - si tout va bien, elle injecte les modifications et marque la ligne comme modifiée en passant "gridModified" à true
 *
 * @param {Object} trs - l'objet jQuery représentant les 3 lignes (left/center/right) correspondant à la ligne saisie
 * @return une promise résolue si la sauvegarde s'est bien passée ou rejetée si l'une des vérifications a refusé la sauvegarde
 */
Grid.prototype.internalSaveRows = function(trs) {
	var self = this;
	// La ligne de donnée
	var modelRow = trs.data('row');
	// La ligne de donnée clonée pour permettre une validation de la ligne complète sans toucher à la ligne d'origine en cas d'erreur
	var cloneRow = $.extend({}, modelRow);
	// Les cellules dans l'ordre des colonnes (car on exclut la dernière de chaque zone servant au drop)
	var tableCells = trs.children(':not(.bbm-grid-drop-cell)').get();
	// Indiquera s'il y a eu au moins une modification
	var modified = false;
	// Indiquera la liste des éventuelles erreurs
	var errors = [];
	// La chaîne des vérifications
	var defer = $.Deferred(), chain = defer;

	// Vérification champ par champ
	var columnIndex = -1;
	function nextColumn() {
		columnIndex++;
		if (columnIndex === self.columns.length) {
			defer.resolve();
			return;
		}
		var column = self.columns[columnIndex];
		var access = self.internalGetCellAccess(column, modelRow, true/*editing*/);
		if (access === 'editable' || access === 'required') {
			var editor = $(tableCells[columnIndex]).children();
			column.validateAndApplyEditor(cloneRow, editor, function(error, changed) {
				if (error)
					errors.push(error);
				if (changed)
					modified = true;
				nextColumn();
			});
		} else {
			nextColumn();
		}
	}
	nextColumn();

	// Validation de la ligne complète
	if (this.onvalidate) {
		chain = chain.then(function() {
			var defer = $.Deferred();
			self.onvalidate(cloneRow, function(errorOrErrors, changed) {
				// A-t-on reçu une erreur en retour ?
				if (typeof errorOrErrors === 'string')
					errors.push(errorOrErrors);
				// A-t-on reçu plusieurs erreurs en retour ?
				else if (errorOrErrors && errorOrErrors.length > 0)
					errors.push.apply(errors, errorOrErrors);
				// L'appel a-t-il modifié aussi la ligne ?
				if (changed)
					modified = true;
				// On continue ci-dessous (= affichage des erreurs ou application des modifications)
				defer.resolve();
			});
			return defer;
		});
	}

	// Une fois toutes les vérifications effectuées
	return chain.then(function() {
		// En cas d'erreur, afficher la ligne en rouge et prévenir
		if (errors.length !== 0) {
			trs.addClass('danger');
			self.onerror(self.target, errors, modelRow);
			return $.Deferred().reject();
		}

		// Ligne OK, on retire la rouge
		trs.removeClass('danger');

		// $.extend ne videra pas les valeurs
		// $.extend(modelRow, cloneRow);
		for (var p in cloneRow) {
			modelRow[p] = cloneRow[p];
		}

		// Indiquer si la ligne est modifiée (MAIS ne pas toucher à l'indicateur précédent)
		if (modified && !modelRow.gridModified)
			modelRow.gridModified = true;

		// Prévenir si la ligne a été modifiée
		if (modified)
			self.target.trigger('grid.rowedited', [modelRow]);
	});
};

/**
 * Cette méthode est appelée quand la largeur du div (middle>center) ou la largeur de la table (middle>center>table) changent.
 * Dans ce cas, elle met à jour la valeur max de l'ascenseur horizontal et le cache s'il n'est plus utile.
 */
Grid.prototype.internalUpdateWidth = function() {
	// à cause de la colonne ajoutée à droite de la partie centrale pour le fond coloré de la ligne sélectionnée,
	// la largeur de la table ne correspond pas à la largeur des colonnes espérée
	// var contentWidth = this.components.middle.find('>.bbm-grid-center>table').outerWidth();
	var columns = this.columns;
	if (this.useFixedColumns)
		columns = columns.slice(this.leftColumnCount, this.columns.length - this.rightColumnCount);
	var contentWidth = columns.reduce(function(cw, column) { return cw + (column.hidden ? 0 : column.width); }, 0);

	// La largeur disponible correspond à la largeur de la partie "top center" car "middle center" a des ascenseurs
	// var availableWidth = this.components.middle.children('.bbm-grid-center').innerWidth();
	var availableWidth = this.components.top.children('.bbm-grid-center').innerWidth();

	// La différence des 2 correspond à la largeur manquante, qui activera un éventuel scroll
	var scrollWidth = Math.floor(contentWidth - availableWidth);
	this.target.toggleClass('bbm-grid-without-hscroll', scrollWidth <= 0);
	this.components.hscroll.data('maxScroll', scrollWidth);
};

/**
 * Cette méthode est appelée quand la hauteur du div (middle>center) ou la hauteur de la table (middle>center>table) changent.
 * Dans ce cas, elle met à jour la valeur min de l'ascenseur vertical et le cache s'il n'est plus utile.
 */
Grid.prototype.internalUpdateHeight = function() {
	// Verticalement, la hauteur nécessaire correspond à la hauteur externe de la table dans "middle center"
	var contentHeight = this.components.middle.find('>.bbm-grid-center>table').outerHeight();

	// La hauteur disponible est tout simplement la hauteur interne de "middle"
	var availableHeight = this.components.middle.innerHeight();

	// La différence des 2 correspond à la hauteur manquante, qui activera un éventuel scroll
	var scrollHeight = Math.floor(contentHeight - availableHeight);
	this.target.toggleClass('bbm-grid-without-vscroll', scrollHeight <= 0);
	this.components.vscroll.data('maxScroll', scrollHeight);
};

/**
 * Cette méthode est appelée pour positionner la grille verticalement :
 * - soit grâce à "scrollTop" quand l'appel vient d'un évènement "scroll"
 * - soit grâce à "clientY" quand on manipule l'ascenseur
 * Le décalage est appliqué aux div (middle) et enregistré dans l'ascenseur vertical (vscroll).
 *
 * @param {number} clientY - la position de la souris quand on manipule l'ascenseur vertical
 * @param {number} scrollTop - le décalage vertical à appliquer quand c'est un évènement "scroll"
 * @param {DOMElement} source - le div qui a lancé un évènement "scroll" ou null si ça vient d'ailleurs
 * @return true si le décalage a effectivement changé
 */
Grid.prototype.internalUpdateScrollTop = function(clientY, scrollTop, source) {
	var currentScroll = this.components.vscroll.data('currentScroll');
	if (scrollTop !== null && Math.round(scrollTop) === currentScroll) // on compare en arronsissant. Sinon, sous Chrome, le scroll vertical est laborieux
		return false;
	var maxScroll = this.components.vscroll.data('maxScroll');
	var parentHeight = this.components.vscroll.innerHeight();
	var handle = this.components.vscroll.children();
	var handleHeight = handle.outerHeight();
	var handleTop, y;
	if (scrollTop === null) {
		y = clientY - this.components.vscroll.offset().top - handleHeight / 2;
		y = Math.max(0, Math.min(parentHeight - handleHeight, y));
		handleTop = y;
		scrollTop = y * maxScroll / (parentHeight - handleHeight);
		if (Math.round(scrollTop) === currentScroll) // on compare en arronsissant. Sinon, sous Chrome, le scroll vertical est laborieux
			return false;
	} else {
		handleTop = scrollTop * (parentHeight - handleHeight) / maxScroll;
	}
	this.components.vscroll.data('currentScroll', scrollTop);
	this.components.middle.children().filter(function() { return this !== source; }).scrollTop(scrollTop);
	handle.css('top', handleTop + 'px');
	return true;
};

/**
 * Cette méthode est appelée pour positionner la grille horizontalement :
 * - soit grâce à "scrollLeft" quand l'appel vient d'un évènement "scroll"
 * - soit grâce à "clientX" quand on manipule l'ascenseur
 * Le décalage est appliqué aux div (*>center) et enregistré dans l'ascenseur horizontal (hscroll).
 *
 * @param {number} clientX - la position de la souris quand on manipule l'ascenseur horizontal
 * @param {number} scrollLeft - le décalage horizontal à appliquer quand c'est un évènement "scroll"
 * @param {DOMElement} source - le div qui a lancé un évènement "scroll" ou null si ça vient d'ailleurs
 * @return true si le décalage a effectivement changé
 */
Grid.prototype.internalUpdateScrollLeft = function(clientX, scrollLeft, source) {
	var currentScroll = this.components.hscroll.data('currentScroll');
	if (scrollLeft !== null && scrollLeft === currentScroll)
		return false;
	var maxScroll = this.components.hscroll.data('maxScroll');
	var parentWidth = this.components.hscroll.innerWidth();
	var handle = this.components.hscroll.children();
	var handleWidth = handle.outerWidth();
	var handleLeft, x;
	if (scrollLeft === null) {
		x = clientX - this.components.hscroll.offset().left - handleWidth / 2;
		x = Math.max(0, Math.min(parentWidth - handleWidth, x));
		handleLeft = x;
		scrollLeft = x * maxScroll / (parentWidth - handleWidth);
		if (scrollLeft === currentScroll)
			return false;
	} else {
		handleLeft = scrollLeft * (parentWidth - handleWidth) / maxScroll;
	}
	this.components.hscroll.data('currentScroll', scrollLeft);
	this.components.center.filter(function() { return this !== source; }).scrollLeft(scrollLeft);
	handle.css('left', handleLeft + 'px');
	return true;
};

/**
 * Cette méthode est appelée pour mettre à jour la partie dédiée à la pagination, c'est à dire :
 * - cacher la zone si elle n'est pas utile (visibleRows.length < pageSize)
 * - (dés)activer les 4 boutons permettant de changer de page
 * - ajuster la plage ("1-100 sur 957" par exemple)
 */
Grid.prototype.internalUpdatePagination = function() {
	var pagination = this.components.pagination;
	var first = this.pageIndex * this.pageSize + 1;
	var last = Math.min(this.visibleRows.length, first + this.pageSize - 1);
	var format = this.lang.paginationRangeFormat;
	// Vu en réunion le 05/09/2016
	// Afin de pouvoir rechanger pageSize pour une valeur plus petite, ne plus cacher la barre de navigation si "pageSize" dépasse "visibleRows.length".
	// La classe "bbm-grid-without-pagination" existe toujours et permet de désactiver la gestion de la pagination à la construction en passant "pageSize" à false.
	// this.target.toggleClass('bbm-grid-without-pagination', this.visibleRows.length <= this.pageSize);
	pagination.find('>.btn-group>button:nth-child(-n+2)').prop('disabled', this.pageIndex === 0);
	pagination.find('>.btn-group>button:nth-child(n+3)').prop('disabled', this.pageIndex === this.getPageCount() - 1);
	pagination.children('span').text(format.replace('%first', first).replace('%last', last).replace('%count', this.visibleRows.length));
};

/**
 * Cette méthode est appelée pour mettre à jour le regroupement restant fixe au dessus des lignes (>main>group) en fonction du scroll "top".
 * - cacher le regroupement si on est en haut
 * - rechercher la ligne de regroupement cachée (même partiellement) la plus proche du haut
 * - rappeler la valeur de ce regroupement dans le regroupement fixe en haut
 *
 * @param {number} top - le décallage vertical en cours
 * @return {boolean} retourne true si la visiblité du regroupement change (affiché <--> caché)
 */
Grid.prototype.internalUpdateGroup = function(top) {
	var fixedGroup = this.components.group;
	var wasVisible = fixedGroup.is(':visible');
	top = (typeof top === 'number') ? top : this.components.vscroll.data('currentScroll') || 0;
	if (this.groupColumn === null || (top === 0 && this.groupRows.length > 0)) {
		if (wasVisible)
			fixedGroup.hide();
		return wasVisible;
	} else {
		fixedGroup.show();
		//Recherche dichotomique de la dernière ligne de regroupement non visible entièrement
		var groupRow = null;
		BaseAPI.arrayDichotomique(this.groupRows, function(row, index) {
			// Si la ligne est visible, on recherche une ligne cachée avant, dans la moitié gauche (retourne -1)
			if (row.offsetTop >= top)
				return -1;
			// Si la ligne n'est pas visible, on la prend et on cherche mieux après, dans la moitié droite (retourne 1)
			groupRow = row;
			return 1;
		});
		// Texte dans le regroupement, si une ligne est trouvée ou si la grille est vide
		var groupContent = '';
		if (groupRow !== null)
			groupContent = this.groupColumn.ready ? (this.groupColumn.groupContent($(groupRow).data('row')) || ' ') : '...';
		else if (this.groupRows.length === 0)
			groupContent = '...';
		// Affichage ou non de la ligne de regroupement fixe en haut
		if (groupContent) {
			var groupButton = '<a href="#" class="bbm-grid-remove-group" title="' + this.lang.columnRemoveGrouping + '">' + this.defaultOptions.removeGroupHTML + '</a>';
			var groupColumnTitle = typeof this.groupColumn.title === 'function' ? this.groupColumn.title() : this.groupColumn.title;
			fixedGroup.text(groupColumnTitle + ' : ' + groupContent).append(groupButton);
			return !wasVisible;
		} else {
			fixedGroup.hide();
			return wasVisible;
		}
	}
};

/**
 * Cette méthode est appelée quand la liste des lignes visibles changent afin de mettre à jour les filtres dynamiques le souhaitant
 *
 * Le principe est d'appeler "column.updateFilter" pour chaque qui l'a définie afin d'ajuster le filtre aux lignes actuellement visibles.
 */
Grid.prototype.internalUpdateFilters = function() {
	var visibleRows = this.visibleRows;
	var singleFilteredRows = this.singleFilteredRows;
	this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row>th').each(function() {
		var th = $(this), column = th.data('column');
		if (column.createFilter && column.updateFilter)
			column.updateFilter(th.children(), visibleRows, singleFilteredRows);
	});
};

/**
 * Cette méthode est appelée quand la liste des lignes visibles changent afin de mettre à jour les cumuls en bas de colonne
 *
 * Le principe général est le suivant :
 * - récupérer la liste des colonnes ayant un cumul en bas et initialiser la valeur de départ (footer.initialize)
 * - parcourir les lignes pour cumuler (footer.add)
 * - finaliser la valeur des cumuls (footer.finalize)
 */
Grid.prototype.internalUpdateFooters = function() {
	// Préparer la liste des footers
	var footerColumns = [];
	this.columns.forEach(function(column) {
		if (typeof column.footer === 'object') {
			footerColumns.push(column);
			column.footer.initialize(column);
		}
	});

	// S'il y a au moins un cumul en pied de colonne
	if (footerColumns.length > 0) {
		// Parcourir les lignes tout en vérifiant si elle est visible
		var visibleRowsIndex = 0;
		this.rows.forEach(function(row) {
			// Vérifier si la ligne est visible, c'est à dire si la ligne de rows est la ligne en cours dans visibleRows
			var visible = this.visibleRows.length >= visibleRowsIndex && this.visibleRows[visibleRowsIndex] === row;
			if (visible)
				visibleRowsIndex++;

			// Cumul des footers
			footerColumns.forEach(function(column) {
				column.footer.add(column, row, visible);
			});
		}.bind(this));

		// MAJ des footers
		var footerCells = this.components.bottom.find('>*>table>tfoot>tr.bbm-grid-footer-row>th');
		footerColumns.forEach(function(column) {
			var cell = footerCells[this.columns.indexOf(column)];
			column.footer.finalize(column, cell, this.rows);
		}.bind(this));
	}
};

/**
 * Cette méthode déplace une colonne représentée par srcHeader à une position représentée par dstHeader
 * - si dstHeader à plus à gauche que srcHeader, on déplace _à la place de_ dstHeader
 * - si dstHeader à plus à droite que srcHeader, on déplace _après_ dstHeader
 *
 * Le déplacement se fait en retirant les cellules (td/th) de leur position d'origine pour les insérer à leur position d'arrivée
 */
Grid.prototype.internalMoveColumn = function(srcHeader, dstHeader) {
	var srcClassName = srcHeader.closest('table').parent()[0].className,
		srcColumn = srcHeader.data('column'),
		srcIndex = this.columns.indexOf(srcColumn),
		srcLeft = srcIndex < this.leftColumnCount,
		srcRight = srcIndex >= this.columns.length - this.rightColumnCount,
		dstClassName = dstHeader.closest('table').parent()[0].className,
		dstIndex,
		insertAfter,
		dstLeft = false,
		dstRight = false;

	if (! dstHeader.is('.bbm-grid-drop-cell')) {
		// Drop sur une autre colonne
		dstIndex = this.columns.indexOf(dstHeader.data('column'));
		insertAfter = srcIndex < dstIndex;
		dstLeft = dstIndex < this.leftColumnCount;
		dstRight = dstIndex >= this.columns.length - this.rightColumnCount;
	} else {
		// Détection si on drop à gauche, à droite ou au centre
		var div = dstHeader.closest('table').parent();
		insertAfter = false;

		if (div.is('.bbm-grid-left')) {
			dstIndex = 0;
			dstLeft = true;
		} else if (div.is('.bbm-grid-right')) {
			dstIndex = this.columns.length;
			dstRight = true;
		} else {
			dstIndex = this.columns.length - this.rightColumnCount;
		}
	}

	// On ne fait rien si on reste au même index dans le même DOM element.
	if (srcIndex === dstIndex && srcHeader[0] === dstHeader[0])
		return false;

	// Mise à jour des compteurs lors du retrait de la colonne de là où elle était
	if (srcLeft && ! dstLeft)
		this.leftColumnCount--;
	if (srcRight && ! dstRight)
		this.rightColumnCount--;
	// Mise à jours des compteurs lors de l'ajout de la colonne là où elle doit aller
	if (dstLeft && ! srcLeft)
		this.leftColumnCount++;
	if (dstRight && ! srcRight)
		this.rightColumnCount++;
	// Retirer la colonne de là où elle était
	this.columns.splice(srcIndex, 1);
	// Ajouter la colonne là où on la dépose
	this.columns.splice(dstIndex, 0, srcColumn);

	// Récupération des cellules des colonnes source (à déplacer) et destination (repère)
	var srcTables = this.target.find('.' + srcClassName + '>table'),
		dstTables = this.target.find('.' + dstClassName + '>table'),
		srcRows = srcTables.find('>thead>*,>tfoot>*,>tbody>tr.bbm-grid-row:not(.bbm-grid-loadable), >tbody>tr.bbm-grid-layout-row'),
		dstRows = dstTables.find('>thead>*,>tfoot>*,>tbody>tr.bbm-grid-row:not(.bbm-grid-loadable), >tbody>tr.bbm-grid-layout-row'),
		srcCells = srcRows.children(':nth-child(' + (srcHeader.index()+1) + ')'),
		dstCells = dstRows.children(':nth-child(' + (dstHeader.index()+1) + ')');

	// Cacher les cellules à déplacer
	srcCells.hide();
	// Déplacer les cellules de la colonne au nouvel emplacement
	$.each(srcCells, function(index, value) {
		if (insertAfter)
			$(value).insertAfter(dstCells[index]);
		else
			$(value).insertBefore(dstCells[index]);
	});
	// Petit effet en apparaissant pour montrer le nouvel emplacement de la colonne
	srcCells.fadeIn();

	// Prévenir un éventuel listener
	this.target.trigger('grid.columnmoved', [srcColumn, srcIndex, dstIndex]);
	return true;
};

/**
 * Cette fonction recherche un contrôle pouvant prendre le focus sur la ligne sélectionnée.
 *
 * @param {DOMEvent} event - l'évènement du clic qui nous indiquera la cellule ayant le ficus (d'où on part)
 * @param {string} selector - le sélecteur CSS pour la recherche d'élément à qui donner le focus
 * @param {boolean} forward - indique si on va vers la droite (true) ou vers la gauche (false)
 * @return une Promise résolue avec le composant jQuery à qui donner le focus (si trouvé) ou rejetée si aucun composant n'a été trouvé
 */
Grid.prototype.internalFindControlToFocus = function(event, selector, forward) {
	// Le résultat, qui sera résolu ou rejeté selon ce qu'on trouve
	var result = $.Deferred();
	// La cellule ayant le focus
	var sourceCell = $(event.target).closest('td');
	// L'index de la ligne dans la table
	var sourceRowIndex = sourceCell.parent().index();
	// Les 3 lignes (left/center/right) représentant la ligne complète
	var tableRows = this.components.middle.find('>*>table>tbody>:nth-child(' + (sourceRowIndex + 1) + ')');
	// Les cellules dans l'ordre des colonnes (car on exclut la dernière de chaque zone servant au drop)
	var tableCells = tableRows.children(':not(.bbm-grid-drop-cell)').get();
	// En !forward, on parcourt le tableau dans le sens inverse
	if (!forward)
		tableCells.reverse();
	// Parcourt des cellules pour rechercher un composant à qui donner le focus
	for (var i = tableCells.indexOf(sourceCell[0]) + 1; i < tableCells.length; i++) {
		var control = $(tableCells[i]).find(selector);
		if (control.length > 0)
			return result.resolve(control);
	}
	return result.reject();
};

/**
 * Cette fonction recherche une ligne avant / après la ligne sélectionnée pour lui transmettre le focus.
 *
 * @param {DOMEvent} event - l'évènement du clic qui nous indiquera la cellule ayant le ficus (d'où on part)
 * @param {string} selector - le séelcteur CSS pour la recherche d'élément à qui donner le focus
 * @param {boolean} forward - indique si on va vers le bas (true) ou vers le haut (false)
 * @param {boolean} keepIndex - indique si on reste sur la même colonne (true) ou si on a atteint une extrémité de ligne (false)
 * @return true si on a trouvé un composant à qui on a donné le focus
 * @return une Promise résolue avec le composant jQuery à qui donner le focus (si trouvé) ou rejetée si aucun composant n'a été trouvé
 */
Grid.prototype.internalFindRowToFocus = function(event, selector, forward, keepIndex) {
	var self = this;
	// Le résultat, qui sera résolu ou rejeté selon ce qu'on trouve
	var result = $.Deferred();
	// La cellule ayant le focus
	var sourceCell = $(event.target).closest('td');
	// L'index de la colonne, en faisant attention aux colonnes fixes
	var columnIndex = keepIndex ? this.findColumnIndexOfCell(sourceCell) : undefined;
	// La ligne à atteindre (la suivante si forward, la précédente sinon)
	var targetRow = forward ? sourceCell.parent().next() : sourceCell.parent().prev();
	// On zappe les lignes de regroupement et les lignes filtrées
	while (targetRow.length > 0 && !targetRow.hasClass('bbm-grid-row')) {
		targetRow = forward ? targetRow.next() : targetRow.prev();
	}
	// Aucune ligne trouvée donc aucun composant trouvé
	if (targetRow.length === 0)
		return result.reject();
	// On a trouvé une autre ligne alors on tente de changer de ligne
	this.internalSelectRow(targetRow).then(function() {
		// Les 3 lignes (left/center/right) représentant la ligne complète
		var tableRows = self.components.middle.find('>*>table>tbody>:nth-child(' + (targetRow.index() + 1) + ')');
		// Les cellules dans l'ordre des colonnes (car on exclut la dernière de chaque zone servant au drop)
		var tableCells = tableRows.children(':not(.bbm-grid-drop-cell)').get();
		if (keepIndex) {
			// Flêches haut/bas => on sélectionne la cellule de la même colonne
			tableCells = [tableCells[columnIndex]];
		} else if (! forward) {
			// Shift+Tab alors que le début de ligne est atteint => on parcourt la ligne précédente dans l'ordre inverse
			tableCells.reverse();
		} else {
			// Shift+Tab alors que la fin de ligne est atteinte => on parcourt la ligne suivante dans l'ordre normal
		}
		// Parcours des cellules pour rechercher un composant à qui donner le focus
		for (var i = 0; i < tableCells.length; i++) {
			var control = $(tableCells[i]).find(selector);
			if (control.length > 0) {
				result.resolve(control);
				return;
			}
		}
		// Aucun composant trouvé => rejeté
		result.reject();
	}, function() {
		// Changement de ligne refusé => rejeté
		result.reject();
	});
	return result;
};

/**
 * Cette méthode calcule l'index de la colonne associée à la cellule donnée.
 * Le résultat est le suivant :
 * - cell.index() pour les colonnes fixes à gauche
 * - cell.index() + this.leftColumnCount pour les colonnes du centre
 * - cell.index() + this.columns.length - this.rightColumnCount pour les colonnes fixes à droite
 *
 * @param {Object} cell - l'objet jQuery représentant la celulle
 * @return l'index de la colonne associée à la cellule donnée
 */
Grid.prototype.findColumnIndexOfCell = function(cell) {
	var index = cell.index();
	var div = cell.closest('div');
	if (div.hasClass('bbm-grid-left'))
		return index;
	if (div.hasClass('bbm-grid-right'))
		return index + this.columns.length - this.rightColumnCount;
	return index + this.leftColumnCount;
};

/**
 * Cette méthode retourne la colonne dont le nom est demandé ou retourne null si aucune colonne n'a ce nom.
 *
 * @param {String} name - le nom de la colonne recherchée
 * @return la colonne trouvée ou null si aucune colonne n'a ce nom
 */
Grid.prototype.findColumnByName = function(name) {
	for (var i = 0; i < this.columns.length; i++) {
		if (this.columns[i].name === name)
			return this.columns[i];
	}
	return null;
};

/**
 * Calcule le nombre de page disponible, en fonction de this.visibleRows.length et this.pageSize
 *
 * @return le nombre de page disponible
 */
Grid.prototype.getPageCount = function() {
	return this.visibleRows.length === 0 ? 1 : (Math.floor((this.visibleRows.length - 1) / this.pageSize) + 1);
};

/**
 * Affiche la page demandée
 *
 * @param {number} pageIndex - l'index de la page souhaitée, entre 0 et getPageCount()-1
 */
Grid.prototype.moveToPage = function(pageIndex) {
	if (pageIndex < 0 || pageIndex >= this.getPageCount())
		throw new Error('Index de page non valide ' + pageIndex);
	this.pageIndex = pageIndex;
	this.internalUpdateGridRows();
	this.internalUpdatePagination();
	this.internalUpdateGroup();
	this.internalUpdateHeight();
	this.internalUpdateScrollableRows(true);
	// On notifie le changement de page par un évènement
	this.target.trigger('grid.pagechanged', [this.pageIndex, this.pageSize]);
};

/** Affiche la première page */
Grid.prototype.moveToFirstPage = function() {
	this.moveToPage(0);
};

/** Affiche la page précédente */
Grid.prototype.moveToPreviousPage = function() {
	this.moveToPage(Math.max(0, this.pageIndex - 1));
};

/** Affiche la page suivante */
Grid.prototype.moveToNextPage = function() {
	this.moveToPage(Math.min(this.getPageCount() - 1, this.pageIndex + 1));
};

/** Affiche la dernière page */
Grid.prototype.moveToLastPage = function() {
	this.moveToPage(this.getPageCount() - 1);
};

/**
 * Cette méthode permet d'afficher ou de cacher la ligne de filtre rapide en haut des colonnes
 *
 * @param {boolean} value - "true" pour afficher, "false" pour cacher ou "undefined" pour alterner
 */
Grid.prototype.toggleFilters = function(value) {
	var rows = this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row');
	rows.toggle(value);
	this.internalUpdateHeight();
	this.internalUpdateScrollableRows(true); // pour la ligne qui a pu apparaitre dans les grilles scrollable
	// Prévenir les éventuels listeners
	this.target.trigger('grid.togglefilters', [rows.is(':visible')]);
};

/**
 * Cette méthode indique par true/false si un des filtres rapides en en-tête de colonne est actuellement actif.
 * La présence (ou non) de filtre supplémentaires dans "this.rowFilters" ne compte pas.
 *
 * @return true si un filtre est actif et false sinon.
 */
Grid.prototype.isFiltered = function() {
	var tableFilterCells = this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row>th'); // th mais pas td
	var haveFilterActive = false;
	this.columns.forEach(function(column, columnIndex) {
		var cell = $(tableFilterCells[columnIndex]);
		if (column.createFilter)
			haveFilterActive = haveFilterActive || !!column.prepareRowFilter(cell.children());
	});
	return haveFilterActive;
};

/**
 * Vide les filtres rapides en en-tête de colonne et recalcule les lignes visibles si demandé
 *
 * @param {boolean} recalculate - true pour rafraîchir la grille aussitôt si un filtre était actif, false ou undefined pour patienter
 */
Grid.prototype.clearFilters = function(recalculate) {
	var tableFilterCells = this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row>th'); // th mais pas td
	var modified = false;
	var lang = this.lang;
	this.columns.forEach(function(column, columnIndex) {
		var cell = $(tableFilterCells[columnIndex]);
		if (column.createFilter && !!column.prepareRowFilter(cell.children())) {
			modified = true;
			cell.empty();
			column.createFilter(cell, lang);
		}
	});
	if (modified && recalculate)
		this.updateFilters();
};

/**
 * Ajoute un filtre personnalisé de la grille et recalcule les lignes visibles si demandé
 *
 * @param {Function} filter - la fonction de filtre à ajouter
 * @param {boolean} recalculate - true pour rafraîchir la grille aussitôt, false ou undefined pour patienter
 */
Grid.prototype.addRowFilter = function(filter, recalculate) {
	var i = this.rowFilters.indexOf(filter);
	if (i === -1)
		this.rowFilters.push(filter);
	if (recalculate)
		this.updateFilters();
};

/**
 * Supprime un filtre personnalisé de la grille et recalcule les lignes visibles si demandé
 *
 * @param {Function} filter - la fonction de filtre à retirer
 * @param {boolean} recalculate - true pour rafraîchir la grille aussitôt, false ou undefined pour patienter
 */
Grid.prototype.removeRowFilter = function(filter, recalculate) {
	var i = this.rowFilters.indexOf(filter);
	if (i !== -1)
		this.rowFilters.splice(i, 1);
	if (recalculate)
		this.updateFilters();
};

/**
 * Ajoute ou supprime un filtre personnalisé de la grille et recalcule les lignes visibles si demandé
 *
 * @param {Function} filter - la fonction de filtre à ajouter (si absente) ou à supprimer (si présente)
 * @param {boolean} recalculate - true pour rafraîchir la grille aussitôt, false ou undefined pour patienter
 */
Grid.prototype.toggleRowFilter = function(filter, recalculate) {
	var i = this.rowFilters.indexOf(filter);
	if (i === -1)
		this.rowFilters.push(filter);
	else
		this.rowFilters.splice(i, 1);
	if (recalculate)
		this.updateFilters();
};

/**
 * Demande à la grille de prendre en compte les filtres, par exemple si les filtres personnalisés changent
 */
Grid.prototype.updateFilters = function() {
	// Préparer la liste des filtres de lignes
	var filters = [].concat(this.rowFilters);
	this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row>th').each(function() { // th mais pas td
		var th = $(this),
			column = th.data('column'),
			filter = column.createFilter ? column.prepareRowFilter(th.children()) : false;
		if (filter)
			filters.push(filter);
	});

	// Pour que les filtres dynamiques fonctionnent bien, il ne suffit pas de savoir
	// si une ligne est filtrée (oui/non) mais si au moins 2 colonnes la filtre
	this.singleFilteredRows = [];

	if (filters.length === 0) {
		// S'il n'y a pas de filtre, le calcul des lignes visibles est facile
		this.visibleRows = [].concat(this.rows);
	} else {
		// Sinon, il faudra parcourir les lignes pour voir si elles sont visibles ou non
		this.visibleRows.length = 0;
		this.visibleRows = this.rows.filter(function(row) {
			// Au départ, aucune filtre pour cette ligne
			var filterCount = 0;
			// Puis on parcourt les filtres
			$.each(filters, function(filterIndex, filter) {
				// ... on compte le nombre de filtre pour la ligne
				if (!filter(row))
					filterCount++;
				// ... puis on s'arrête dès qu'on sait qu'au moins 2 filtres sont actifs pout la ligne
				return filterCount < 2;
			});
			// Une fois les parcourus, on met de côté les lignes en mono-filtre
			if (filterCount === 1)
				this.singleFilteredRows.push(row);
			// Au final, on ne conserve que les lignes visibles
			return filterCount === 0;
		}.bind(this));
	}

	// Dans de rares cas, on souhaite ajuster la liste des lignes visibles en fonction des filtres.
	// Par exemple, on affiche l'OP parente, même si elle est filtrée, quand l'une de ses OPs filles est visible
	if (this.postFilters) {
		this.postFilters(this.visibleRows, this.rows);
	} 

	// Initialiser la sélection
	this.target.trigger('grid.rowselected', undefined);
	// Prévenir les éventuels listeners
	this.target.trigger('grid.rowcountchanged', [this.visibleRows.length]);	
	// MAJ des filtres dynamiques, par exemple "asSelect" ou "asMultiSelect"
	this.internalUpdateFilters();
	// MAJ des footers
	this.internalUpdateFooters();
	// Afficher la première page
	this.moveToFirstPage();
};

/**
 * Cette fonction est appelée pour changer le tri
 *
 * @param {GridColumn} col - la colonne selon laquelle trier ou "null" pour retirer le tri
 * @param {boolean} ascending - indique si le tri est ascendant (true) ou descendant (false)
 * @param {boolean} skipSort - indique si on attend avant de rafraîchir
 */
Grid.prototype.sortCol = function(col, ascending, skipSort) {
	this.sortColumn = col;
	this.sortAscending = ascending;
	this.target.trigger('grid.sortchanged', [col, ascending]);
	if (this.sortColumn != null && (this.groupColumn === this.sortColumn))
		this.groupCol(null, null, true);
	if (! skipSort) {
		this.updateSort();
		this.moveToFirstPage();
	}
};

/**
 * Cette fonction est appelée pour changer le regroupement
 *
 * @param {GridColumn} col - la colonne selon laquelle regrouper ou "null" pour retirer le regroupement
 * @param {boolean} ascending - indique si le regroupement est ascendant (true) ou descendant (false)
 * @param {boolean} skipSort - indique si on attend avant de rafraîchir
 */
Grid.prototype.groupCol = function(col, ascending, skipSort) {
	this.groupColumn = col;
	this.groupAscending = ascending;
	this.target.trigger('grid.groupchanged', [col, ascending]);
	if (this.groupColumn != null && (this.sortColumn === this.groupColumn))
		this.sortCol(null, null, true);
	if (! skipSort) {
		this.updateSort();
		this.moveToFirstPage();
	}
};

/**
 * Cette méthode rafraîchit les données nécessaires suite à un changement de tri ou de regroupement.
 * Dans ce cas, il faut :
 * - mettre à jour l'indicateur de tri (suppression + ajout dans la colonne correspondant à sortColumn)
 * - retrier les lignes dans l'ordre du regroupement puis dans l'ordre du tri au sein du regroupement
 * - enfin, retrier les lignes visibles
 */
Grid.prototype.updateSort = function() {
	// Retirer l'indicateur précédent (valable si le regroupement ou le tri change)
	var headerRows = this.components.top.find('>*>table>thead>tr.bbm-grid-header-row');
	headerRows.find('span.bbm-grid-sort-indicator').remove();
	// Ajouter un indicateur de tri dans la bonne colonne
	if (this.sortColumn) {
		$('<span class="bbm-grid-sort-indicator" />')
			.addClass(this.sortAscending ? 'bbm-grid-sort-indicator-ascending' : 'bbm-grid-sort-indicator-descending')
			.prependTo(headerRows.children('th')[this.columns.indexOf(this.sortColumn)]);
	}
	// Trier toutes les lignes
	this.rows.sort(function(row1, row2) {
		// - dans l'ordre du regroupement
		var n = (this.groupColumn && this.groupColumn.ready) ? this.groupColumn.compare(row1, row2, !!this.groupAscending) : 0;
		if (n !== 0)
			return n;
		// - ou dans l'ordre du tri au sein du même regroupement
		return (this.sortColumn && this.sortColumn.ready) ? this.sortColumn.compare(row1, row2, !!this.sortAscending) : 0;
	}.bind(this));
	// Mettre à jour la liste des lignes visibles
	this.visibleRows = this.rows.filter(function(row) {
		return this.visibleRows.indexOf(row) >= 0;
	}.bind(this));
};

/**
 * Cette méthode permet d'afficher ou de cacher le "pied-de-page" de la grille, c'est à dire la ligne du bas affichant d'éventuels totaux
 *
 * @param {boolean} value - "true" pour afficher, "false" pour cacher ou "undefined" pour alterner
 */
Grid.prototype.toggleFooters = function(value) {
	this.components.bottom.toggle(value);
	this.internalUpdateHeight();
	this.internalUpdateScrollableRows(true); // pour la ligne qui a pu apparaître dans les grilles "scrollable"
};

/**
 * Cette méthode demande à la grille de rafraîchir le filtre et les données de la colonne "column"
 *
 * @param {GridColumn} column - la colonne à rafraîchir
 */
Grid.prototype.updateCol = function(column) {
	var self = this;

	// Si le contenu de la colonne servait au tri ou au regroupement change, il faut tout retrier
	if (column === this.groupColumn || column === this.sortColumn) {
		this.updateSort();
		this.updateFilters();
		return;
	}

	// Index de la colonne à rafraîchir
	var columnIndex  = this.columns.indexOf(column);
	// La cellule de filtre
	var filterCell = $(this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row>th')[columnIndex]); // th mais pas td
	// La langue, utilisée par createFilter et createEditor
	var lang = this.lang;

	// Si le contenu de la colonne a un filtre actif, les lignes sont triées mais il faut quand même tout refiltrer
	if (column.createFilter && !!column.prepareRowFilter(filterCell.children())) {
		this.updateFilters();
		return;
	}

	// MAJ de la cellule du filtre
	filterCell.empty();
	if (column.createFilter)
		column.createFilter(filterCell, lang);
	//mise à jour des données du filtre par rapport aux données de la grille
	if (column.updateFilter)
		column.updateFilter(filterCell.children(), self.visibleRows, self.singleFilteredRows);

	// Information sur la bande (left/center/right) dans laquelle se trouve la colonne
	var selector, columnOffset;
	if (columnIndex < this.leftColumnCount) {
		selector = '.bbm-grid-left';
		columnOffset = 0;
	} else if (columnIndex < this.columns.length - this.rightColumnCount) {
		selector = '.bbm-grid-center';
		columnOffset = this.leftColumnCount;
	} else {
		selector = '.bbm-grid-right';
		columnOffset = this.columns.length - this.rightColumnCount;
	}

	// MAJ des données
	this.components.middle.children(selector).find('>table>tbody>tr.bbm-grid-row:not(.bbm-grid-loadable)>:nth-child(' + (columnIndex - columnOffset + 1) + ')').each(function() {
		var td = $(this).empty();
		var tr = td.parent();
		var modelRow = tr.data('row');
		var access = self.internalGetCellAccess(column, modelRow, tr.hasClass('bbm-grid-editing'));
		['notready', 'readonly', 'editable', 'required'].forEach(function(a) {
			td.toggleClass(self.defaultOptions.cellClasses[a], a === access);
		});
		if (access === 'notready')
			td.append(self.defaultOptions.notReadyHTML);
		else if (access === 'readonly')
			td.append(column.content(modelRow));
		else
			column.createEditor(modelRow, td, lang, access === 'required', self.onchange);
		if (self.oncustomize)
			self.oncustomize(td, column, modelRow, tr.is('.bbm-grid-selected'));
	});

	// Ajustement de la hauteur
	this.internalUpdateHeight();
};

/**
 * Cette méthode ajuste la grille en fonction de la visibilité des colonnes
 */
Grid.prototype.toggleHiddenColumns = function(columns, hidden) {
	var self = this;
	columns.forEach(function(column) {
		var selector, index = self.columns.indexOf(column);
		if (index < 0)
			return;
		if (self.useFixedColumns && index < self.leftColumnCount) {
			selector = self.components.left;
		} else if (self.useFixedColumns && index >= self.columns.length - self.rightColumnCount) {
			selector = self.components.right;
			index = index - self.columns.length + self.rightColumnCount;
		} else {
			selector = self.components.center;
			index = index - self.leftColumnCount;
		}
		// Si "hidden" est précisé, on l'utilise. Sinon, on inverse la visibilité de la colonne
		column.hidden = (typeof hidden === 'boolean') ? hidden : !column.hidden;
		selector.find('>table>*>tr>:nth-child(' + (index + 1) + ')').toggleClass('bbm-grid-hidden', column.hidden);
	});
	// Ajuster la largeur suite à l'affichage ou au masquage de colonnes
	this.internalUpdateWidth();
	// UNIQUEMENT SI NECESSAIRE, recalculer les lignes.
	// Outre que c'est plus long, ça oblige en plus à cliquer 2 fois pour changer de ligne.
	if (!this.useFixedRowHeight) {
		this.internalUpdateGridRows();
		this.internalUpdateHeight();
		this.internalUpdateScrollableRows(true);
	}
};

/**
 * Cette méthode recherche et met à jour les lignes 'tr' correspondant à la ligne donnée
 *
 * @param {DOM ou jQuery} modelRow - la ligne à rafraîchir
 */
Grid.prototype.updateModelRow = function(modelRow) {
	// On récupère les lignes de la partie centrale (toujours présentes)
	var centerRows = this.components.middle.find('>.bbm-grid-center>table>tbody>tr.bbm-grid-row');
	// On recherche parmi celle-ci la ligne correspondant à l'objet "modelRow"
	var tableRow = centerRows.filter(function(index, tr) {
		return $(tr).data('row') === modelRow;
	});
	// Si on l'a trouvé, on force son raffraichissement (qui mettra à jour les éventuelles parties gauche/droite)
	if (tableRow.length > 0 && !tableRow.hasClass('bbm-grid-loadable')) {
		tableRow.addClass('bbm-grid-loadable');
		this.updateRow(tableRow);
	}
};

/**
 * Cette méthode demande à la grille de rafraîchir les parties lignes gauche/centre/droite en ne fournissant qu'une des trois 'tr'
 *
 * @param {DOM ou jQuery} tr - une ligne indiquant quelle données rafraîchir
 */
Grid.prototype.updateRow = function(tr) {
	var tableRow = $(tr);
	// Si la ligne est déjà chargée, il n'y a rien d'autre à faire
	if (!tableRow.hasClass('bbm-grid-loadable'))
		return;
	// On récupère l'objet correspondant à la ligne
	var modelRow = tableRow.data('row');
	// On récupère les lignes des 3 sections gauche / centre / droite
	var tableRows = this.components.middle.find('>*>table>tbody>:nth-child(' + (tableRow.index() + 1) + ')');
	// On vérifie si la ligne est sélectionnée
	var selected = tableRow.hasClass('bbm-grid-selected');
	// On vérifie si la ligne est modifiable
	var editing = tableRow.hasClass('bbm-grid-editing');
	// On génère le contenu de la ligne
	this.internalUpdateRow(tableRows, modelRow, selected, editing);
};

/**
 * Cette méthode demande à rafraîchir toutes les lignes. Cela revient en fait à un appel à moveToFirstPage()
 */
Grid.prototype.updateRows = function() {
	if(this.pageIndex && this.pageIndex < this.getPageCount()) {
		this.moveToPage(this.pageIndex);
		return;
	}
	this.moveToFirstPage();
};

/**
 * Cette méthode permet de sélectionner une ligne dans la grille en précisant l'objet métier "row".
 * Elle recherche alors la "tr" correspondant à cette ligne et la sélectionne si elle la trouve.
 * @param {Object} row - l'objet métier (client, article, ...) à sélectionner
 * @return une promise résolue si la ligne a été sélectionnée ou rejetée si la sélection ne change pas.
 */
Grid.prototype.selectRow = function(row) {
	if (!this.selectable)
		throw new Error('La sélection n\'est pas activée dans la grille');
	var visibleIndex = this.visibleRows.indexOf(row);
	if (visibleIndex >= 0) {
		var tr = $(this.components.middle.find('>.bbm-grid-center>table>tbody>tr.bbm-grid-row')[visibleIndex - (this.pageIndex*this.pageSize)]);
		return this.internalSelectRow(tr);
	}
	return $.Deferred().reject();
};

/**
 * Cette méthode ajoute une ligne "row" au début ou à la fin en fonction de "first".
 * Elle délègue en fait par un appel à this.addRows([row], first);
 */
Grid.prototype.addRow = function(row, first) {
	this.addRows([row], first);
};

/**
 * Cette méthode ajoute un tableau de lignes "rows" au début ou à la fin en fonction de "first" et, pour cela, effectue les opérations suivantes :
 * - ajoute les lignes à this.rows
 * - ajoute les lignes à this.visibleRows
 * - prévenir les listeners en lançant un évènement "grid.rowcountchanged"
 * - mettre à jour les totaux
 * - se positionner en dernière page ou en première page selon la position demandée par "first"
 */
Grid.prototype.addRows = function(rows, first) {
	// Ajouter les lignes au début ou à la fin selon la position demandée
	rows.forEach(function(row) {
		if (first) {
			this.rows.splice(0, 0, row);
			this.visibleRows.splice(0, 0, row);
		} else {
			this.rows.push(row);
			this.visibleRows.push(row);
		}
	}.bind(this));

	// Prévenir les éventuels listeners
	this.target.trigger('grid.rowcountchanged', [this.visibleRows.length]);
	// MAJ des filtres dynamiques, par exemple "asSelect" ou "asMultiSelect"
	this.internalUpdateFilters();
	// MAJ des footers
	this.internalUpdateFooters();
	// Afficher la première page
	if (first) {
		this.moveToFirstPage();
	} else {
		this.moveToLastPage();
	}
};

/**
 * Cette méthode supprime une ligne de la grille.
 * Elle délègue en fait par un appel à removeRows([row]);
 */
Grid.prototype.removeRow = function(row) {
	this.removeRows([row]);
};

/**
 * Cette méthode supprime un tableau de lignes et, pour cela, effectue les opérations suivantes :
 * - suppression de this.rows
 * - suppression de this.visibleRows
 * - si au moins une suppression de this.visibleRows, prévenir les listeners en lançant un évènement "grid.rowcountchanged"
 * - si au moins une suppression de this.rows, mettre à jour les totaux et revenir à la première page
 */
Grid.prototype.removeRows = function(rows) {
	var rowCountBefore = this.rows.length;
	var visibleRowCountBefore = this.visibleRows.length;

	rows.forEach(function(row) {
		var index = this.rows.indexOf(row);
		if (index >= 0) {
			this.rows.splice(index, 1);
			index = this.visibleRows.indexOf(row);
			if (index >= 0)
				this.visibleRows.splice(index, 1);
		}
	}.bind(this));

	if (this.rows.length !== rowCountBefore) {
		// Prévenir les éventuels listeners
		if (this.visibleRows.length !== visibleRowCountBefore)
			this.target.trigger('grid.rowcountchanged', [this.visibleRows.length]);
		// MAJ des filtres dynamiques, par exemple "asSelect" ou "asMultiSelect"
		this.internalUpdateFilters();
		// MAJ des footers
		this.internalUpdateFooters();
		// Afficher la première page
		this.moveToFirstPage();
	}
};

/**
 * Cette méthode modifie les lignes manipulées par la grille "this.rows" et recalcule ce qu'il faut.
 */
Grid.prototype.setRows = function(rows) {
	// Utiliser le tableau de lignes
	this.rows = rows;
	// S'assurer que les lignes sont triées correctement
	this.updateSort();
	// Mettre à jour les filtres
	this.updateFilters();
};

/**
 * Appelée à être supprimée car n'est pas l'implementation souhaitée (cf. Datasharing)
 * Cette méthode modifie les lignes manipulées par la grille "this.rows" et recalcule ce qu'il faut.
 * Ne gère pas les tris et les filtres
 */
Grid.prototype.setVisibleRows = function(rows, count) {
	if (this.visibleRows.length > count)
		this.visibleRows.length = 0;
	var idx = 0;
	var offset = this.pageIndex * this.pageSize;
	var max = offset + Math.min(rows.length, this.pageSize);
	for (var i = offset; i<max; i++) {
		this.rows[i] = rows[idx];
		this.visibleRows[i] = rows[idx];
		idx++;
	}
	this.internalUpdateGridRows();
	this.internalUpdatePagination();
	this.internalUpdateGroup();
	this.internalUpdateHeight();
	this.internalUpdateScrollableRows(true);
};

/**
 * Cette méthode tenter de sauvegarder les lignes en cours de modification et retourne true s'il n'y a pas d'erreur
 *
 * @return une promise résolue si la saisie a été validée ou rejetée en cas d'erreur de saisie
 */
Grid.prototype.saveEditing = function() {
	// Récupérer les lignes en cours de modification
	var editingRows = this.components.middle.find('>*>table>tbody>tr.bbm-grid-editing');
	// Si il n'y a pas de ligne en cours d'édition , on peut sortir.
	if (editingRows.length <= 0)
		return $.Deferred().resolve();
	// Demander d'appliquer les modifications
	return this.internalSaveRows(editingRows);
};


/**
 * Cette méthode alimente un objet destiné à être sauvegardé par la suite dans localStorage
 * Ordre, largeur, colonnes fixes et filtres rapides
 *
 * @return ?
 */
Grid.prototype.saveStateToObject = function(obj) {
	var columns = [];

	// Pour chaque colonne un objet { name: ... , width: ..., filter: ... }
	var filterRows = this.components.top.find('>*>table>thead>tr.bbm-grid-filter-row');
	filterRows.children('th').each(function(i, th) {
		var col = $(th).data('column');
		var o = { name: col.name, size: col.width };
		if (col.saveFilter) {
			var filter = col.saveFilter($(th).children());
			if (filter)
				o.filter = filter;
		}
		columns.push(o);
	});

	obj.filters = filterRows.is(':visible');
	obj.columns = columns;
	obj.groupColumnName = this.groupColumn ? this.groupColumn.name : null;
	obj.groupAscending = this.groupAscending;
	obj.sortColumnName = this.sortColumn ? this.sortColumn.name : null;
	obj.sortAscending = this.sortAscending;
	obj.leftColumnCount = this.leftColumnCount;
	obj.rightColumnCount = this.rightColumnCount;
};

/**
 * Cette fonction redimensionne toutes les colonnes par rapport au contenu présent dans ses cellules,
 * en en-tete, corps ou pied
 */
Grid.prototype.adjustColumnsWidth = function() {
	this.components.top.find('.ui-resizable-e').each(function(index, dom) {
		var self = $(dom);
		self.trigger('dblclick');
	});
};

/** Les langues supportées par la grille */
Grid.prototype.langs = {
	en: {
		momentLocale: 'en',
		paginationRowsPerPage: 'Rows per page',
		paginationRangeFormat: '%first-%last of %count',
		paginationFirstPage: 'First page',
		paginationPreviousPage: 'Previous page',
		paginationNextPage: 'Next page',
		paginationLastPage: 'Last page',
		columnPopoverTitle: 'Actions',
		columnSortAscending: 'Sort ascending',
		columnSortDescending: 'Sort descending',
		columnGroupAscending: 'Group ascending',
		columnGroupDescending: 'Group descending',
		columnRemoveGrouping: 'Remove grouping',
		filterSelect: 'filter',
		filterContains: 'contains',
		filterEquals: 'equals to',
		filterNotEquals: 'differs from',
		filterEmpty: 'empty',
		filterNotEmpty: 'not empty',
		filterMinMax: 'min - max',
		filterMin: 'min',
		filterMax: 'max'
	},
	fr: {
		momentLocale: 'fr',
		paginationRowsPerPage: 'Lignes par page',
		paginationRangeFormat: '%first-%last sur %count',
		paginationFirstPage: 'Première page',
		paginationPreviousPage: 'Page précédente',
		paginationNextPage: 'Page suivante',
		paginationLastPage: 'Dernière page',
		columnPopoverTitle: 'Actions',
		columnSortAscending: 'Tri ascendant',
		columnSortDescending: 'Tri descendant',
		columnGroupAscending: 'Regroupement ascendant',
		columnGroupDescending: 'Regroupement descendant',
		columnRemoveGrouping: 'Supprimer le regroupement',
		filterSelect: 'filtre',
		filterContains: 'contient',
		filterEquals: 'égal(e) à',
		filterNotEquals: 'différent(e) de',
		filterEmpty: 'vide',
		filterNotEmpty: 'non vide',
		filterMinMax: 'min - max',
		filterMin: 'min',
		filterMax: 'max'
	},
	de: {
		momentLocale: 'de',
		paginationRowsPerPage: 'Zeilen auf Zeite',
		paginationRangeFormat: '%first-%last von %count',
		paginationFirstPage: 'Erste Seite',
		paginationPreviousPage: 'Vorherige Seite',
		paginationNextPage: 'Nächste Seite',
		paginationLastPage: 'Letzte Seite',
		columnPopoverTitle: 'Aktionen',
		columnSortAscending: 'Aufsteigende Sortierung',
		columnSortDescending: 'Absteigende Sortierung',
		columnGroupAscending: ' Aufsteigende Gruppierung',
		columnGroupDescending: 'Absteigende Gruppierung',
		columnRemoveGrouping: 'Gruppierung entfernen',
		filterSelect: 'filtern',
		filterContains: 'enthält',
		filterEquals: 'entspricht',
		filterNotEquals: 'anders als',
		filterEmpty: 'leer',
		filterNotEmpty: 'nicht leer',
		filterMinMax: 'min - max',
		filterMin: 'mindestens',
		filterMax: 'höchstens'
	}
};

/** Les options par défaut, utilisées dans le constructeur et permettant de changer les options par défaut au niveau applicatif, par exemple pour les colonnes booléennes */
Grid.prototype.defaultOptions = {
	/** La langue à utiliser pour la grille (les langues disponibles sont définies dans Grid.prototype.langs) */
	lang: 'en',
	/** La liste des lignes de la grille (voir "addRowFilter" pour filtrer éventuellement les lignes affichées) */
	rows: [],
	/** La liste des colonnes, dans l'ordre initial (l'ordre des colonnes peut changer donc ce tableau ne doit pas être partagé entre plusieurs grilles) */
	columns: [],
	/** La liste de fonctions filtrant les lignes (l'option permet de positionner un filtre dès le départ. Sinon, addRowFilter permet de l'ajouter plus tard) */
//	rowFilters: [],
	/** Cette fonction permet de compléter la liste des lignes filtrées avec des lignes supplémentaires. Ex: les lignes mères dans l'affichage d'une grille hiérarchique */
//	postFilters: function(visibleRows, rows) {}
	/** Le nombre de lignes affichées dans chaque page (ou false pour désactiver la pagination) */
	pageSize: 20,
	/** true/false pour activer/bloquer la gestion des colonnes fixes à gauche ou à droite */
	useFixedColumns: false,
	/** true/false pour figer/libérer la hauteur de ligne fixe de lignes */
	useFixedRowHeight: true,
	/** Le nombre de colonnes fixes à gauche initialement */
	leftColumnCount: 0,
	/** Le nombre de colonnes fixes à droite initialement */
	rightColumnCount: 0,
	/** La largeur de la colonne permettant de fixer une première colonne à gauche ou à droite */
	dropColumnWidth: 20,
	/** La largeur des colonnes sans taille initiale, le temps de faire le dimensionnement auto */
	defaultColumnWidth: 40,
	/** true/false pour afficher/cacher la ligne des filtres par colonne (chaque colonne gère son composant de filtre avec sa propriété "createFilter" (qui peut être "undefined" pour empêcher le filtre sur cette colonne) */
	filters: true,
	/** true/false pour afficher/cacher la ligne des totaux de colonnes (chaque colonne indique son contenu par sa propriété "footer") */
	footers: true,
	/** true/false pour que les totaux, quand ils sont affichésn appraissent en haut / en bas */
	footersOnTop: false,
	/** true/false pour activer/bloquer la sélection de ligne (voir "editable" et "oneditrow" pour que les lignes sélectionnée passent en modification) */
	selectable: true,
	/** true/false pour activer/bloquer l'édition des lignes (chaque colonne gère son composant d'édition avec sa propriété "createEditor" (qui peut être "undefined" pour empêcher l'édition sur cette colonne) */
	editable: true,
	/** true/false pour activer/bloquer la navigation au clavier avec les flêches et tab (désactiver par défaut car surcharge le comportement normal du focus) */
	keyboard: false,
	/** true/false pour activer/bloquer le tri sur les colonnes (le tri de chaque colonne est géré individuellement avec les propriétés "sortable" et "compare") */
	sortable: true,
	/** true/false pour activer/bloquer le regroupement sur les colonnes (le regroupement de chaque colonne est géré individuellement avec les propriétés "groupable", "compare" et "groupContent") */
	groupable: true,
	/** true/false pour activer/bloquer le déplacement de colonnes (si actif, toutes les colonnes peuvent l'être) */
	moveable: true,
	/** true/false pour activer/bloquer le redimensionnement de colonnes (chaque colonne gère son redimensionnement avec ses propriétés "resizable" et "width") */
	resizable: true,
	/** true/false pour activer/bloquer le chargement des lignes au moment de leur affichage (à activer pour les grosses grilles) */
	scrollable: false,
	/** true/false pour afficher/cacher les bordures des cellules */
	bordered: true,
	/** Le contenu du bouton dans les lignes de regroupement permettant de supprimer les regroupements */
	removeGroupHTML: '<span class="glyphicon glyphicon-remove"></span>',
	/** Le contenu des boutons de navigation dans les pages */
	moveToFirstPageHTML: '<span class="glyphicon glyphicon-step-backward"></span>',
	moveToPreviousPageHTML: '<span class="glyphicon glyphicon-chevron-left"></span>',
	moveToNextPageHTML: '<span class="glyphicon glyphicon-chevron-right"></span>',
	moveToLastPageHTML: '<span class="glyphicon glyphicon-step-forward"></span>',
	/** Le contenu des cellules tant que la colonne n'est pas prête */
	notReadyHTML: '<span class="bbm-grid-loading glyphicon glyphicon-refresh" />',
	/** Les classes CSS qui permettront de personnaliser l'affichage en fonction des droits */
	cellClasses: {
		'notready': '',
		'readonly': '',
		'editable': 'bbm-grid-cell-editable',
		'required': 'bbm-grid-cell-required',
	},

	/**
	 * Permet d'indiquer à la grille si la ligne est editable ou non.
	 * @param row - l'objet métier dont on veut savoir s'il est editable
	 * @return true pour activer la saisie sur cette ligne, false pour la bloquer
	 */
	/*
	oneditrow: function(row) {
		return true;
	},
	*/

	/**
	 * Permet de contrôler pour chaque cellule si la saisie est possible, voire obligatoire.
	 * Si la fonction ne renvoie rien, ceux sont les droits "editable" et "required" de la colonne qui sont pris en compte.
	 * Sinon, la fonction doit renvoyer un objet ayant 2 propriétés booléennes "editable" et "required".
	 *
	 * @param column - la colonne dont on veut savoir si elle est éditable
	 * @param row - l'objet métier dont on veut savoir s'il est editable
	 * @return un object { editable?, required? } ou undefined pour utiliser les droits par défaut de la colonne
	 */
	/*
	oneditcell: function(column, row) {
		return { editable: true, required: false };
	},
	*/

	/**
	 * Permet d'effectuer des vérifications entre colonnes et indiquer une éventuelle erreur ou modification.
	 * @param cloneRow - une copie de la ligne avec les modifications faites dans la grille
	 * @param {function} callbackErrorChange - la callback appelée en retour avec 2 paramètres exclusifs "error" et "change"
	 * @return ne retourne rien
	 */
	/*
	onvalidate: function(cloneRow, callbackErrorChange) {
		doSomething().then(function() {
			// pas d'erreur
			callbackErrorChange(null, false);
			// pas d'erreur mais doSomething a modifié la ligne
			callbackErrorChange(null, false);
			// une seule erreur
			callbackErrorChange('Une erreur', false);
			// plusieurs erreurs
			callbackErrorChange(['Erreur 1', 'Erreur2], false);
		});
	},
	*/

	/**
	 * Permet de personnaliser la façon d'afficher les erreurs car le comportement par défaut utilise window.alert
	 * @param grid - correspond à l'élément dans lequel on a créé la grille
	 * @param errors - est un tableau des erreurs
	 * @param row - fournit la ligne en cours de saisie
	 */
	onerror: function(grid, errors, row) {
		if (errors)
			window.alert(errors.join('\n'));
	},

	/**
	 * Pour pouvoir personnaliser une cellule de la grille, par exemple afin de changer la couleur dans la grille
	 * @param cell - la cellule de la grille que l'on s'apprête à dessiner
	 * @param column - la colonne dont on veut personnaliser une cellule
	 * @param row - l'objet métier dont on veut personnaliser une cellule
	 * @param selected - indique si la ligne est sélectionnée
	 */
	/*
	oncustomize: function(cell, column, row, selected) {

	},
	*/

	/* Options par défaut pour les colonnes */

	booleanTrueText: 'Oui',
	booleanFalseText: 'Non',
	booleanTrueContent: '<span class="glyphicon glyphicon-ok text-success" />',
	booleanFalseContent: '',
	numberNaNMessage: function(p) { return 'La saisie n\'est pas un nombre'; },
	selectionTrueContent: '<span class="glyphicon glyphicon-check" />',
	selectionFalseContent: '<span class="glyphicon glyphicon-unchecked" />',
	placeholderColor: '#999',
	textColor: '#333',
};

(function($) {
	// Ce tout petit plugin permet de factoriser le code de création de "select" pour les filtres
	// sur les colonnes Boolean/Select/MultiSelect (gestion des options et de la couleur grisé)
	$.fn.gridFilterSelect = function(parent, lang, options, optionValueProperty, optionTextProperty) {
		var color1 = Grid.prototype.defaultOptions.placeholderColor;
		var color2 = Grid.prototype.defaultOptions.textColor;
		// Cas particulier : appeler ".gridFilterSelect('refresh')" va rafraîchir en fonction de la présence ou non d'un filtre
		if (parent === 'refresh') {
			return this.each(function() {
				$(this).css('color', (this.selectedIndex === 0) ? color1 : color2);
			});
		}
		return this.addClass('form-control')
			.append($('<option value="" data-option-index="0" selected="selected" />').text(lang.filterSelect).css('color', color1))
			.append($.map(options, function(option, optionIndex) {
				var optionText = (typeof optionTextProperty === 'string') ? option[optionTextProperty] : optionTextProperty(option);
				var optionValue = option[optionValueProperty].toString();
				return $('<option />').attr('value', optionValue).attr('data-option-index', optionIndex + 1).text(optionText).css('color', color2).get(0);
			}))
			.appendTo(parent)
			.change(function() {
				$(this).css('color', (this.selectedIndex === 0) ? color1 : color2);
			})
			// .change() // ne pas appeler "change" car ça relance le calcul des filtres
			.css('color', color1); // mais juste ajuster la couleur
	};

	// Encore (!) un petit plugin pour faciliter la création de "dropdown-menu" dans les grilles
	$.fn.gridDropDownMenu = function(builder) {
		function showDropDownMenu(event) {
			var td, dropdown, ul;
			// Eviter le # dans l'URL
			event.preventDefault();
			// Ne pas remonter à la ligne pour ne pas la sélectionner
			event.stopPropagation();
			// Cacher le dropdown existant si on reclique sur la même pastille
			td = $(event.target).closest('td');
			dropdown = td.find('.dropdown');
			if (dropdown.length > 0) {
				// Ce remove n'est pas nécessaire car le listener "mousedown" sur le document y arrivera
				// C'est juste que l'IHM est plus réactive pour refermer le menu avec ce remove.
				dropdown.remove();
				// Et on s'arrête ici dans tous les cas pour ne pas créer un autre menu
				return;
			}
			// Créer un dropdown sinon
			dropdown = $('<div class="dropdown" style="position: absolute; ">');
			ul = $('<ul class="dropdown-menu" />').appendTo(dropdown);
			builder(ul);
			td.append(dropdown);
			// On utilise pas ul.dropdown('toggle')
			// car il y a un bug avec Chrome qui est considéré comme mobile
			dropdown.addClass('open');

			// Pour refermer le menu, on écoute sur le document directement
			$(document).on('mousedown', hideDropDownMenu);
		}

		function hideDropDownMenu(event) {
			// On cherche le dropdown tout de suite, avant qu'un autre apparaisse éventuellement
			var dropdown =  $('td > .dropdown.open');
			// On désenregistre le listener pour ce dropdown
			$(document).off('mousedown', hideDropDownMenu);
			// On attend qu'un éventuel clic sur une entrée de menu soit traitée avant de fermer le menu
			setTimeout(function() {
				dropdown.remove();
			}, 300);
		}

		return this.click(showDropDownMenu);
	};

	// Composant grille en jQuery, proposant 3 appels possibles
	$.fn.grid = function(params) {
		// 1. Création avec .grid({ ... });
		if (typeof params === 'object') {
			return this.each(function() {
				$(this).data('grid', new Grid(this, params));
			});
		}

		// 2. Récupération avec .grid();
		if (typeof params === 'undefined') {
			return this.data('grid');
		}

		// 3. Destruction avec .grid('destroy');
		if (params === 'destroy') {
			return this.each(function() {
				var self = $(this), grid = self.data('grid');
				if (grid) {
					grid.destroy();
					self.removeData('grid');
				}
			});
		}

		// Erreur sinon
		throw new Error('Paramètre non supporté pour le composant grille : ' + params);
	};

})(window.jQuery);
